import './Dashboard.css';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { RotatingLines } from "react-loader-spinner";
import newDashboardService from '../Services/DashboardService';
import {Context} from '../Context';
import BudgetLineChart from '../Components/BudgetLineChart';
import * as d3 from 'd3';
import { ImArrowUp,ImArrowDown } from "react-icons/im";
import { FaCommentDollar } from "react-icons/fa";
import { IoMdClose,IoMdArrowDropdown,IoMdArrowDropright  } from "react-icons/io";

const ACUMATICA_PROJECT_TRANSACTIONS_LINK = 'https://cornerstoneinc.acumatica.com/(W(1))/Main?CompanyID=Pilot&ScreenId=PM401000&ProjectID='
const ACUMATICA_PROJECT_LINK = 'https://cornerstoneinc.acumatica.com/(W(3))/Main?CompanyID=Pilot&ScreenId=PM301000&BaseType=P&ContractCD='

const getCompleteCompanyStats = async (apiToken, setSuccess, SetFailure) => {
    newDashboardService.getCompleteCompanyStats(apiToken)
    .then(response =>{
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const createNewCompanyStats = (apiToken, setSuccess, SetFailure, setRefreshingStats) => {
    newDashboardService.createCompleteCompanyStats(apiToken)
    .then(response =>{
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
            setRefreshingStats(false);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            setRefreshingStats(false);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        setRefreshingStats(false);
        console.log(e.toString());
        return null;
    });
};

const createOverUnderDocument = (apiToken, setSuccess, SetFailure, setCreatingOverUnderAdjustments) => {
    newDashboardService.createOverUnderDocument(apiToken)
    .then(response => {
        if(response.status > 199 && response.status < 400){
            setSuccess(response.data.fileName);
            setCreatingOverUnderAdjustments(false);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            setCreatingOverUnderAdjustments(false);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch(e => {
        SetFailure(e.toString());
        setCreatingOverUnderAdjustments(false);
        console.log(e.toString());
        return null;
    });
};

const openOverUnderDocument = (accessToken, fileName) => {
    newDashboardService.downloadFile(accessToken, fileName);
};

const getProcoreLaborData = async (apiToken, setProcoreLaborList,setProcoreErrors,setProjectRequests,setProjectRequestsErrors,setWeeklyRequests,setWeeklyRequestsErrors,setTitles,setTitlesErrors,setProjects,setProjectsErrors,setLaborTimeStamp) => {
    newDashboardService.getProcoreLaborData(apiToken)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setProcoreLaborList(response.data.resources);
            setProjectRequests(response.data.projectRequests);
            setWeeklyRequests(response.data.weeklyRequests);
            setTitles(response.data.titles);
            setProjects(response.data.projects);
            const formattedDate = new Date(response.data.date).toLocaleString(); // formatting the date
            setLaborTimeStamp(formattedDate);
        }
        else{
            setProcoreErrors('Error: ' + response.statusText);
            setProjectRequestsErrors('Error: ' + response.statusText);
            setWeeklyRequestsErrors('Error: ' + response.statusText);
            setTitlesErrors('Error: ' + response.statusText);
            setProjectsErrors('Error: ' + response.statusText);
            setLaborTimeStamp('ERROR');
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        setProcoreErrors(e.toString());
        setProjectRequestsErrors(e.toString());
        setWeeklyRequestsErrors(e.toString());
        setTitlesErrors(e.toString());
        setProjectsErrors(e.toString());
        setLaborTimeStamp('ERROR');
        console.log(e.toString());
        return null;
    });
};

const refreshLaborData = async (apiToken, setProcoreLaborList,setProcoreErrors,setProjectRequests,setProjectRequestsErrors,setWeeklyRequests,setWeeklyRequestsErrors,setTitles,setTitlesErrors,setProjects,setProjectsErrors,setLaborTimeStamp,setRefreshingLaborData) => {
    newDashboardService.refreshLaborData(apiToken)
    .then(response => {
        setRefreshingLaborData(false);
        if(response.status > 199 && response.status < 300){
            setProcoreLaborList(response.data.resources);
            setProjectRequests(response.data.projectRequests);
            setWeeklyRequests(response.data.weeklyRequests);
            setTitles(response.data.titles);
            setProjects(response.data.projects);
            const formattedDate = new Date(response.data.date).toLocaleString(); // formatting the date
            setLaborTimeStamp(formattedDate);
        }
        else{
            setProcoreErrors('Error: ' + response.statusText);
            setProjectRequestsErrors('Error: ' + response.statusText);
            setWeeklyRequestsErrors('Error: ' + response.statusText);
            setTitlesErrors('Error: ' + response.statusText);
            setProjectsErrors('Error: ' + response.statusText);
            setLaborTimeStamp('ERROR');
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        setProcoreErrors(e.toString());
        setProjectRequestsErrors(e.toString());
        setWeeklyRequestsErrors(e.toString());
        setTitlesErrors(e.toString());
        setProjectsErrors(e.toString());
        setLaborTimeStamp('ERROR');
        console.log(e.toString());
        return null;
    });
};

const getFieldServiceLaborData = async (apiToken, setSuccess, SetFailure) => {
    newDashboardService.getFieldServiceLaborData(apiToken)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const getCompleteTechData = async (apiToken, setSuccess, SetFailure) => {
    newDashboardService.getServiceTechnicians(apiToken)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const generateLaborEquipmentReport = async (apiToken, setSuccess, SetFailure) => {
    newDashboardService.generateLaborEquipmentReport(apiToken).then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data.fileName);
            downloadExcelReport(apiToken, response.data.fileName);
        } else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const downloadExcelReport = (apiToken,fileName) => {
    newDashboardService.downloadFile(apiToken,fileName);
};

const getIgnoredTitles = async (apiToken, setSuccess, SetFailure) => {
    newDashboardService.getIgnoredTitles(apiToken)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const updateIgnoredTitles = async (apiToken, titlesObject, setSuccess, SetFailure) => {
    console.log(titlesObject);
    newDashboardService.updateIgnoredTitles(apiToken, titlesObject)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const getLEViews = async (apiToken, setSuccess, SetFailure) => {
    newDashboardService.getLEViews(apiToken)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const createLEViews = async (apiToken, viewsObject, setSuccess, SetFailure) => {
    console.log(apiToken)
    newDashboardService.createLEViews(apiToken, viewsObject)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const updateLEViews = async (apiToken, viewsObject, setSuccess, SetFailure) => {
    newDashboardService.updateLEViews(apiToken, viewsObject)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

const deleteLEView = async (apiToken, viewId, setSuccess, SetFailure) => {
    newDashboardService.deleteLEView(apiToken, viewId)
    .then(response => {
        if(response.status > 199 && response.status < 300){
            setSuccess(response.data);
        }
        else{
            SetFailure('Error: ' + response.statusText);
            console.log('Error: ' + response.statusText);
            return null;
        };
    }).catch( e=> {
        SetFailure(e.toString());
        console.log(e.toString());
        return null;
    });
};

// CALLS TO BACKEND API ABOVE

const Loader = () => {
  return (
    <RotatingLines
      strokeColor="rgb(6, 89, 79)"
      strokeWidth="5"
      animationDuration="0.75"
      width="150"
      visible={true}
    />
  )
};

const BranchTile = ({ title, stats }) => {
    const svgRef = useRef();
    
    // Format currency for display
    const formatCurrency = (value) => {
        if (Math.abs(value) >= 1000000) {
            return `$${(value / 1000000).toFixed(1)}M`;
        } else if (Math.abs(value) >= 1000) {
            return `$${(value / 1000).toFixed(0)}K`;
        } else {
            return `$${value.toFixed(0)}`;
        }
    };

    // Calculate current period data
    const getCurrentPeriodData = () => {
        if (!stats || !stats.budgetedVsActual || !stats.budgetedVsActual.ebita) {
            return { currentBudget: 0, currentActual: 0, performance: 0 };
        };

        const ebitaData = stats.budgetedVsActual.ebita;
        const actualWithValues = ebitaData.actual.filter(d => d.value !== 0);
        if (actualWithValues.length === 0) return { currentBudget: 0, currentActual: 0, performance: 0 };
        
        const currentPeriod = Math.max(...actualWithValues.map(d => d.period));
        
        const currentBudget = ebitaData.budgeted.find(d => d.period === currentPeriod)?.value || 0;
        const currentActual = ebitaData.actual.find(d => d.period === currentPeriod)?.value || 0;
        
        const performance = currentBudget === 0 ? 0 : ((currentActual - currentBudget) / currentBudget) * 100;
        
        return { currentBudget, currentActual, performance, currentPeriod };
    };

    const { currentBudget, currentActual, performance, currentPeriod } = getCurrentPeriodData();

    // Create mini line chart
    useEffect(() => {
        if (!stats || !stats.budgetedVsActual || !stats.budgetedVsActual.ebita) {
            // If no EBITA data, just clear the SVG
            const svg = d3.select(svgRef.current);
            svg.selectAll("*").remove();
            return;
        }

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        const ebitaData = stats.budgetedVsActual.ebita;
        const width = 120;
        const height = 40;
        const margin = { top: 2, right: 2, bottom: 2, left: 2 };
        const innerWidth = width - margin.left - margin.right;
        const innerHeight = height - margin.top - margin.bottom;

        // Filter data to include all periods with actual values (including negatives) or period 0
        const actualDataFiltered = ebitaData.actual.filter(d => d.value !== 0 || d.period === 0);
        
        if (actualDataFiltered.length < 2) return; // Need at least 2 points to draw a line

        const maxPeriod = Math.max(...actualDataFiltered.map(d => d.period));
        const maxValue = Math.max(
            d3.max(ebitaData.budgeted.slice(0, maxPeriod + 1), d => d.value),
            d3.max(actualDataFiltered, d => d.value)
        );
        const minValue = Math.min(
            d3.min(ebitaData.budgeted.slice(0, maxPeriod + 1), d => d.value),
            d3.min(actualDataFiltered, d => d.value)
        );

        const xScale = d3.scaleLinear()
            .domain([0, maxPeriod])
            .range([0, innerWidth]);

        // Adjust scale to handle negative values with proper padding  
        const padding = Math.abs(maxValue - minValue) * 0.1 || Math.abs(maxValue) * 0.1 || 1000;
        const yScale = d3.scaleLinear()
            .domain([minValue - padding, maxValue + padding])
            .range([innerHeight, 0]);

        const chartGroup = svg
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        // Line generators
        const line = d3.line()
            .x(d => xScale(d.period))
            .y(d => yScale(d.value))
            .curve(d3.curveMonotoneX);

        // Add zero line if we have negative values
        if (minValue < 0) {
            chartGroup.append('line')
                .attr('x1', 0)
                .attr('x2', innerWidth)
                .attr('y1', yScale(0))
                .attr('y2', yScale(0))
                .style('stroke', '#666')
                .style('stroke-width', 0.5)
                .style('stroke-dasharray', '2,2')
                .style('opacity', 0.6);
        }

        // Draw budget line (light gray)
        chartGroup.append('path')
            .datum(ebitaData.budgeted.slice(0, maxPeriod + 1))
            .attr('d', line)
            .style('fill', 'none')
            .style('stroke', '#cbd5e0')
            .style('stroke-width', 1.5)
            .style('opacity', 0.7);

        // Draw actual line with color coding
        for (let i = 0; i < actualDataFiltered.length - 1; i++) {
            const currentPoint = actualDataFiltered[i];
            const nextPoint = actualDataFiltered[i + 1];
            
            const currentBudget = ebitaData.budgeted.find(d => d.period === nextPoint.period)?.value || 0;
            // Color red if variance is negative (actual below budget), green otherwise
            const nextVariance = nextPoint.value - currentBudget;
            const isVarianceNegative = nextVariance < 0;
            // Apply flip logic if stats has flip property set to true
            const shouldUseRed = stats.budgetedVsActual.ebita.flip ? !isVarianceNegative : isVarianceNegative;
            const color = shouldUseRed ? '#ef4444' : '#10b981';
            
            chartGroup.append('path')
                .datum([currentPoint, nextPoint])
                .attr('d', line)
                .style('fill', 'none')
                .style('stroke', color)
                .style('stroke-width', 2);
        }
    }, [stats]);

    return (
        <div className="branch-tile">
            <div className="branch-tile-header">
                <h4 className="branch-tile-title">{title}</h4>
                <div className="branch-tile-performance">
                    <span className={`performance-indicator ${performance >= 0 ? 'positive' : 'negative'}`}>
                        {performance >= 0 ? '+' : ''}{performance.toFixed(1)}%
                    </span>
                </div>
            </div>
            
            <div className="branch-tile-chart">
                <svg ref={svgRef}></svg>
            </div>
            
            <div className="branch-tile-stats">
                <div className="stat-item">
                    <span className="stat-label">Budget</span>
                    <span className="stat-value">{formatCurrency(currentBudget)}</span>
                </div>
                <div className="stat-item">
                    <span className="stat-label">Actual</span>
                    <span className="stat-value">{formatCurrency(currentActual)}</span>
                </div>
            </div>
        </div>
    )
};

const SectionTile = ({ title, id, stats, sectionSelected, setSectionSelected }) => {
    const svgRef = useRef();
    
    // Format currency for display
    const formatCurrency = (value) => {
        if (Math.abs(value) >= 1000000) {
            return `$${(value / 1000000).toFixed(1)}M`;
        } else if (Math.abs(value) >= 1000) {
            return `$${(value / 1000).toFixed(0)}K`;
        } else {
            return `$${value.toFixed(0)}`;
        }
    };

    // Calculate current period data
    const getCurrentPeriodData = () => {
        if (!stats || !stats.budgeted || !stats.actual) {
            return { currentBudget: 0, currentActual: 0, performance: 0 };
        }

        const actualWithValues = stats.actual.filter(d => d.value !== 0);
        
        if (actualWithValues.length === 0) {
            return { currentBudget: 0, currentActual: 0, performance: 0 };
        }

        const currentPeriod = Math.max(...actualWithValues.map(d => d.period));
        
        const currentBudget = stats.budgeted.find(d => d.period === currentPeriod)?.value || 0;
        const currentActual = stats.actual.find(d => d.period === currentPeriod)?.value || 0;
        
        const performance = currentBudget === 0 ? 0 : ((currentActual - currentBudget) / currentBudget) * 100;
        
        return { currentBudget, currentActual, performance, currentPeriod };
    };

    const { currentBudget, currentActual, performance } = getCurrentPeriodData();

    // Create mini line chart
    useEffect(() => {
        if (!stats || !stats.budgeted || !stats.actual) {
            // If no data, just clear the SVG
            const svg = d3.select(svgRef.current);
            svg.selectAll("*").remove();
            return;
        }

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        const width = 100;
        const height = 30;
        const margin = { top: 2, right: 2, bottom: 2, left: 2 };
        const innerWidth = width - margin.left - margin.right;
        const innerHeight = height - margin.top - margin.bottom;

        // Filter data to include all periods with actual values (including negatives) or period 0
        const actualDataFiltered = stats.actual.filter(d => d.value !== 0 || d.period === 0);
        
        if (actualDataFiltered.length < 2) {
            return; // Need at least 2 points to draw a line
        }

        const maxPeriod = Math.max(...actualDataFiltered.map(d => d.period));
        const maxValue = Math.max(
            d3.max(stats.budgeted.slice(0, maxPeriod + 1), d => d.value),
            d3.max(actualDataFiltered, d => d.value)
        );
        const minValue = Math.min(
            d3.min(stats.budgeted.slice(0, maxPeriod + 1), d => d.value),
            d3.min(actualDataFiltered, d => d.value)
        );

        const xScale = d3.scaleLinear()
            .domain([0, maxPeriod])
            .range([0, innerWidth]);

        // Adjust scale to handle negative values with proper padding  
        const padding = Math.abs(maxValue - minValue) * 0.1 || Math.abs(maxValue) * 0.1 || 1000;
        const yScale = d3.scaleLinear()
            .domain([minValue - padding, maxValue + padding])
            .range([innerHeight, 0]);

        const chartGroup = svg
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        // Line generators
        const line = d3.line()
            .x(d => xScale(d.period))
            .y(d => yScale(d.value))
            .curve(d3.curveMonotoneX);

        // Add zero line if we have negative values
        if (minValue < 0) {
            chartGroup.append('line')
                .attr('x1', 0)
                .attr('x2', innerWidth)
                .attr('y1', yScale(0))
                .attr('y2', yScale(0))
                .style('stroke', '#666')
                .style('stroke-width', 0.5)
                .style('stroke-dasharray', '2,2')
                .style('opacity', 0.6);
        }

        // Draw budget line (light gray)
        chartGroup.append('path')
            .datum(stats.budgeted.slice(0, maxPeriod + 1))
            .attr('d', line)
            .style('fill', 'none')
            .style('stroke', '#cbd5e0')
            .style('stroke-width', 1)
            .style('opacity', 0.7);

        // Draw actual line with color coding
        for (let i = 0; i < actualDataFiltered.length - 1; i++) {
            const currentPoint = actualDataFiltered[i];
            const nextPoint = actualDataFiltered[i + 1];
            
            const currentBudget = stats.budgeted.find(d => d.period === nextPoint.period)?.value || 0;
            // Color red if variance is negative (actual below budget), green otherwise
            const nextVariance = nextPoint.value - currentBudget;
            const isVarianceNegative = nextVariance < 0;
            // Apply flip logic if stats has flip property set to true
            const shouldUseRed = stats.flip ? !isVarianceNegative : isVarianceNegative;
            const color = shouldUseRed ? '#ef4444' : '#10b981';
            
            chartGroup.append('path')
                .datum([currentPoint, nextPoint])
                .attr('d', line)
                .style('fill', 'none')
                .style('stroke', color)
                .style('stroke-width', 1.5);
        }
    }, [stats]);

    return (
        <div className="section-tile" onClick={() => setSectionSelected(id)}>
            <div className="section-tile-header">
                <h5 className="section-tile-title">{title}</h5>
                <div className="section-tile-performance">
                    <span className={`performance-indicator-small ${performance >= 0 ? 'positive' : 'negative'}`}>
                        {performance >= 0 ? '+' : ''}{performance.toFixed(0)}%
                    </span>
                </div>
            </div>
            
            <div className="section-tile-chart">
                <svg ref={svgRef}></svg>
            </div>
            
            <div className="section-tile-stats">
                <div className="stat-item-small">
                    <span className="stat-label-small">Budget</span>
                    <span className="stat-value-small">{formatCurrency(currentBudget)}</span>
                </div>
                <div className="stat-item-small">
                    <span className="stat-label-small">Actual</span>
                    <span className="stat-value-small">{formatCurrency(currentActual)}</span>
                </div>
            </div>
        </div>
    )
};

const NavigationBar = ({ accessToken, moduleSelection, setModuleSelection, moduleOptions, currentVersion, createNewStats, refreshingStats, generateOverUnderAdjustment, overUnderDocument, 
    generateLaborReport, laborReport, laborTimeStamp, refreshLaborStats, editIgnoredTitles,refreshingLaborData }) => {
    // Render content based on selected module
    const renderModuleContent = () => {
        switch (moduleSelection) {
            case 'P&L Dashboard':
                return (
                    <div className='Dashboard-Navigation-Bar-Content'>
                        <div className='Dashboard-Navigation-Bar-Info'>
                            <div className='Dashboard-Navigation-Bar-Version'>
                                <span className='version-label'>Version</span>
                                <span className='version-value'>{currentVersion}</span>
                            </div>
                        </div>
                        <div className='Dashboard-Navigation-Bar-Actions'>
                            {refreshingStats ? (
                                <div className='nav-loader-container'>
                                    <RotatingLines
                                        strokeColor="rgb(255, 255, 255)"
                                        strokeWidth="3"
                                        animationDuration="0.75"
                                        width="24"
                                        visible={true}
                                    />
                                    <span className='nav-loader-text'>Refreshing...</span>
                                </div>
                            ) : (
                                <button 
                                    className='nav-button primary'
                                    onClick={createNewStats}
                                >
                                    Refresh Stats
                                </button>
                            )}
                        </div>
                    </div>
                );

            case 'Projects Dashboard':
                return (
                    <div className='Dashboard-Navigation-Bar-Content'>
                        <div className='Dashboard-Navigation-Bar-Info'>
                            <div className='Dashboard-Navigation-Bar-Version'>
                                <span className='version-label'>Version</span>
                                <span className='version-value'>{currentVersion}</span>
                            </div>
                        </div>
                        <div className='Dashboard-Navigation-Bar-Actions'>
                                {refreshingStats ? (
                                <div className='nav-loader-container'>
                                    <RotatingLines
                                        strokeColor="rgb(255, 255, 255)"
                                        strokeWidth="3"
                                        animationDuration="0.75"
                                        width="24"
                                        visible={true}
                                    />
                                    <span className='nav-loader-text'>Refreshing...</span>
                                </div>
                            ) : (
                                <button 
                                    className='nav-button primary'
                                    onClick={createNewStats}
                                >
                                    Refresh Stats
                                </button>
                            )}
                            {!overUnderDocument ? (
                            <button className='nav-button primary' onClick={() => generateOverUnderAdjustment()}>
                                Generate Over/Under Adjustments
                            </button>
                            ) : (
                            <button className='nav-button primary' onClick={() => openOverUnderDocument(accessToken, overUnderDocument)}>
                                Download Over/Under Adjustments
                            </button>
                            )}
                        </div>
                    </div>
                );

            case 'Labor & Equipment Dashboard':
                return (
                    <div className='Dashboard-Navigation-Bar-Content'>
                        <div className='Dashboard-Navigation-Bar-Info'>
                            <div className='Dashboard-Navigation-Bar-Version'>
                                <span className='version-label'>Updated</span>
                                <span className='version-value'>{laborTimeStamp}</span>
                            </div>
                        </div>
                        <div className='Dashboard-Navigation-Bar-Actions'>
                            <button className='nav-button primary' onClick={() => editIgnoredTitles()}>
                                Edit Ignored Titles
                            </button>
                            {   !refreshingLaborData &&
                                <button className='nav-button primary' onClick={() => refreshLaborStats()}>
                                    Refresh Labor & Equipment Data
                                </button>
                            }
                            {   refreshingLaborData &&
                                <button className='nav-button primary'>
                                    Refreshing Data... Please Wait...
                                </button>
                            }

                            {!laborReport ? (
                            <button className='nav-button primary' onClick={() => generateLaborReport()}>
                                Generate Labor & Equipment Report
                            </button>
                            ) : (
                            <button className='nav-button primary' onClick={() => downloadExcelReport(accessToken, laborReport)}>
                                Download Labor & Equipment Report
                            </button>
                            )}
                        </div>
                    </div>
                );
            default:
                return (
                    <div className='Dashboard-Navigation-Bar-Content'>
                        <div className='Dashboard-Navigation-Bar-Info'>
                            <span className='default-message'>Select a module to view options</span>
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className='Dashboard-Navigation-Bar'>
            {/* Module Selection - Always visible on the left */}
            <div className='Dashboard-Navigation-Bar-Module-Selection'>
                <div className='module-input-container'>
                    <select 
                        className='module-select-input'
                        value={moduleSelection}
                        onChange={(e) => setModuleSelection(e.target.value)}
                    >
                        {moduleOptions.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Dynamic Content Area - Changes based on module selection */}
            {renderModuleContent()}
        </div>
    );
};

const ProjectComponent = ({ project,setSelectedProject }) => {
    const [ chartHeight, setChartHeight ] = useState(0);
    const [ budgettedRevenueDisplay, setBudgettedRevenueDisplay ] = useState('');
    const [ actualRevenueDisplay, setActualRevenueDisplay ] = useState('');
    const [ billingLevelDisplay, setBillingLevelDisplay ] = useState('');
    const [ budgettedCostsDisplay, setBudgettedCostsDisplay ] = useState('');
    const [ actualCostsDisplay, setActualCostsDisplay ] = useState('');
    const [ overUnderDisplay, setOverUnderDisplay ] = useState('');
    const [ overDueARDisplay, setOverDueARDisplay ] = useState('');

    const [ showTooltip, setShowTooltip ] = useState(false);
    const [ tooltipVisible, setTooltipVisible ] = useState(false);
    const [ tooltipPosition, setTooltipPosition ] = useState({ x: 0, y: 0 });
    
    const formatShortNumber = (value) => {
        if (value == null || isNaN(value)) return '';
        const absValue = Math.abs(value);
        if (absValue >= 1_000_000) {
            return (value / 1_000_000).toFixed(2) + 'M';
        } else if (absValue >= 1_000) {
            return (value / 1_000).toFixed(2) + 'K';
        } else {
            return value.toFixed(2);
        }
    };

    // Format currency for display in tooltip
    const formatCurrency = (value) => {
        if (value == null || isNaN(value)) return '$0.00';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    };

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            return 'Invalid Date';
        }
    };

    // Handle mouse events for tooltip with improved positioning
    const handleMouseEnter = (event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setTooltipPosition({
            x: rect.left + rect.width / 2,
            y: rect.top - 10
        });
        setTooltipVisible(true);
        // Small delay to ensure the tooltip is rendered before showing
        setTimeout(() => setShowTooltip(true), 10);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
        // Keep tooltip visible until transition completes
        setTimeout(() => setTooltipVisible(false), 300);
    };

    const createDisplayFigures = () => {
        setBudgettedRevenueDisplay(formatShortNumber(project.revisedBudgetedRevenue));
        setActualRevenueDisplay(formatShortNumber(project.actualRevenue));
        setBillingLevelDisplay(formatShortNumber(project.billingLevel));
        setBudgettedCostsDisplay(formatShortNumber(project.revisedBudgetedCosts));
        setActualCostsDisplay(formatShortNumber(project.actualCosts));
        setOverUnderDisplay(formatShortNumber(project.requiredAdjustment));
        setOverDueARDisplay(formatShortNumber(project.overdueAR));
    };

    const calculateChartHeight = (value) => {
        const minValue = 200000;
        const maxValue = 200000000;
        const minHeight = 60;
        const maxHeight = 220;
        if (!value || value <= minValue) return minHeight;
        if (value >= maxValue) return maxHeight;
        // Logarithmic scaling for better visual distribution
        const scale = (Math.log(value) - Math.log(minValue)) / (Math.log(maxValue) - Math.log(minValue));
        return Math.round(minHeight + scale * (maxHeight - minHeight));
    };

    useEffect(() => {
        if(project && project.revisedBudgetedRevenue > 0 && (project.revisedBudgetedCosts > 0 || project.actualCosts > 0)) {
            setChartHeight(calculateChartHeight(project.revisedBudgetedRevenue));
            createDisplayFigures();
        };
    },[project]);

    // Returns the height in px for a value, as a % of chartHeight (0 to chartHeight)
    const calculateComponentHeight = (value) => {
        if (!project || !project.revisedBudgetedRevenue || !value || chartHeight === 0) return 0;
        const percent = Math.abs(value) / Math.abs(project.revisedBudgetedRevenue);
        return Math.round(Math.max(0, Math.min(1, percent)) * chartHeight);
    };


    const chartStyle = {
        '--totalChartHeight': `${chartHeight}px`,
        '--costChartHeight': `${calculateComponentHeight(project.revisedBudgetedCosts)}px`,
        '--revenueActualHeight': `${calculateComponentHeight(project.actualRevenue)}px`,
        '--costActualHeight': `${calculateComponentHeight(project.actualCosts)}px`,
        '--costValueActualHeight': `${calculateComponentHeight(project.actualCosts)-12 > 0 ? calculateComponentHeight(project.actualCosts)-12 : 0}px`,
        '--costBudgettedHeight': `${calculateComponentHeight(project.revisedBudgetedCosts)-calculateComponentHeight(project.actualCosts)-10}px`,

        '--billingLevel': `${calculateComponentHeight(project.billingLevel)}px`,
        '--billingLevelNotification': `${calculateComponentHeight(project.billingLevel) + 5 > chartHeight ? calculateComponentHeight(project.billingLevel) - 25 : calculateComponentHeight(project.billingLevel) }px`,
        '--billingValueHeight': `${calculateComponentHeight(project.billingLevel)-calculateComponentHeight(project.actualRevenue)-15 > 0 ?  calculateComponentHeight(project.billingLevel)-calculateComponentHeight(project.actualRevenue)-15 : 0}px`,
        '--revenueBudgettedHeight': `${calculateComponentHeight(project.revisedBudgetedRevenue)-calculateComponentHeight(project.billingLevel)-calculateComponentHeight(project.actualRevenue)-22}px`,

        '--adjustmentRequired': `${calculateComponentHeight(project.requiredAdjustment)}px`,
        '--adjustmentLevel': `${calculateComponentHeight(project.billingLevel+project.overUnder)-3}px`,
    };

    // Calculate project performance metrics for tooltip
    const getProjectMetrics = () => {
        if (!project) return {};
        
        const revenueVariance = project.revisedBudgetedRevenue - project.actualRevenue;
        const costVariance = project.revisedBudgetedCosts - project.actualCosts;
        const profitMargin = project.revisedBudgetedRevenue ? 
            (((project.revisedBudgetedRevenue - project.revisedBudgetedCosts) / project.revisedBudgetedRevenue) * 100) : 0;
        const actualProfitMargin = project.actualRevenue ? 
            ((project.actualRevenue - project.actualCosts) / project.actualRevenue * 100) : 0;
        const completionPercentage = project.revisedBudgetedRevenue ? 
            (project.actualCosts / project.revisedBudgetedCosts) * 100 : 0;

        return {
            revenueVariance,
            costVariance,
            profitMargin,
            actualProfitMargin,
            completionPercentage
        };
    };

    const metrics = getProjectMetrics();

    // Tooltip Component with smart positioning
    const ProjectTooltip = () => {
        if (!tooltipVisible || !project) return null;

        const openInvoicesCount = project.overdueInvoices ? 
            project.overdueInvoices.filter(invoice => invoice.status === 'Open').length : 0;
        
        const tasksList = project.tasks ? Object.values(project.tasks) : [];

        // Calculate smart positioning
        const calculatePosition = () => {
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const tooltipWidth = Math.min(500, viewportWidth - 40);
            const margin = 10; // Reduced margin for more space
            
            let x = tooltipPosition.x;
            let y = margin; // Always position near the top of the screen
            let transform = 'translate(-50%, 0%)'; // Always show below the top margin
            
            // Calculate available height (full screen minus top and bottom margins)
            const availableHeight = viewportHeight - (margin * 2);
            
            // Adjust horizontal position to keep tooltip within viewport
            if (x - tooltipWidth / 2 < margin) {
                x = tooltipWidth / 2 + margin;
            } else if (x + tooltipWidth / 2 > viewportWidth - margin) {
                x = viewportWidth - tooltipWidth / 2 - margin;
            }
            
            return {
                left: `${x}px`,
                top: `${y}px`,
                transform,
                maxWidth: `${tooltipWidth}px`,
                maxHeight: `${availableHeight}px` // Use full available height
            };
        };

        const positionStyle = calculatePosition();

        return (
            <div 
                className={`project-tooltip ${showTooltip ? 'show' : 'hide'}`}
                style={{
                    position: 'fixed',
                    ...positionStyle,
                    zIndex: 1000,
                    pointerEvents: 'none'
                }}
            >
                <div className="project-tooltip-content">
                    <div className="project-tooltip-header">
                        <h3>{project.name}</h3>
                        <span className={`project-status ${project.status.toLowerCase()}`}>
                            {project.status}
                        </span>
                    </div>

                    <div className="project-tooltip-sections">
                        {/* Basic Information */}
                        <div className="tooltip-section">
                            <h4>Project Details</h4>
                            <div className="tooltip-info-grid">
                                <span className="label">Project ID:</span>
                                <span className="value">{project.projectId}</span>
                                <span className="label">Branch:</span>
                                <span className="value">{project.branch}</span>
                                <span className="label">Start Date:</span>
                                <span className="value">{formatDate(project.startDate)}</span>
                                <span className="label">Project Type:</span>
                                <span className="value">{project.projectType}</span>
                            </div>
                        </div>

                        {/* Financial Overview */}
                        <div className="tooltip-section">
                            <h4>Revenue</h4>
                            <div className="tooltip-info-grid">
                                <span className="label">Original Contract:</span>
                                <span className="value">{formatCurrency(project.contractAmount)}</span>
                                <span className="label">Revised Contract:</span>
                                <span className="value">{formatCurrency(project.revisedBudgetedRevenue)}</span>
                                <span className="label">Revenue Remaining:</span>
                                <span className={`value ${metrics.revenueVariance < 0 ? 'negative' : ''}`}>{formatCurrency(metrics.revenueVariance)}</span>
                                <span className="label">Actual Revenue:</span>
                                <span className={`value ${project.overUnder > 0 ? 'positive' : project.overUnder < 0 ? 'negative' : ''}`}>{formatCurrency(project.actualRevenue)}</span>
                                <span className="label">Billing Level:</span>
                                <span className="value">{formatCurrency(project.billingLevel)}</span>
                                <span className="label">Existing Adjustment:</span>
                                <span className={`value ${project.existingRevenueAdjustment > 0 ? 'neutral' : project.existingRevenueAdjustment < 0 ? 'negative' : ''}`}>{formatCurrency(project.existingRevenueAdjustment)}</span>
                            </div>
                        </div>

                        {/* Financial Overview */}
                        <div className="tooltip-section">
                            <h4>Cost</h4>
                            <div className="tooltip-info-grid">
                                <span className="label">Original Budgeted:</span>
                                <span className="value">{formatCurrency(project.originalBudgetedCosts)}</span>
                                <span className="label">Revised Budgeted:</span>
                                <span className="value">{formatCurrency(project.revisedBudgetedCosts)}</span>
                                <span className="label">Cost Remaining:</span>
                                <span className={`value ${project.actualCosts > project.revisedBudgetedCosts ? 'negative' : ''}`}>{formatCurrency(metrics.costVariance)}</span>
                                <span className="label">Actual Costs:</span>
                                <span className={`value ${project.actualCosts > project.revisedBudgetedCosts ? 'negative' : ''}`}>{formatCurrency(project.actualCosts)}</span>

                            </div>
                        </div>

                        {/* Performance Metrics */}
                        <div className="tooltip-section">
                            <h4>Performance</h4>
                            <div className="tooltip-info-grid">
                                <span className="label">Completion:</span>
                                <span className={`value ${metrics.completionPercentage > 100 ? 'negative' : ''}`}>{metrics.completionPercentage > 100 ? 100 : metrics.completionPercentage.toFixed(1)}%</span>
                                <span className="label">Budgeted Profit Margin:</span>
                                <span className={`value ${metrics.profitMargin <= 0 ? 'negative' : metrics.profitMargin > 0 && metrics.profitMargin < 25 ? 'neutral' : ''}`}>{metrics.profitMargin.toFixed(1)}%</span>
                                <span className="label">Actual Profit Margin:</span>
                                <span className={`value ${metrics.actualProfitMargin > metrics.profitMargin ? 'positive' : (metrics.actualProfitMargin <= 0) && (project.overUnder < 0) ? 'negative' : (metrics.actualProfitMargin > metrics.profitMargin) &&  (metrics.actualProfitMargin > 0) ? 'neutral' : ''}`}>{metrics.actualProfitMargin.toFixed(1)}%</span>
                                <span className="label">Over/Under:</span>
                                <span className={`value ${project.overUnder > 0 ? 'neutral' : project.overUnder < 0 ? 'negative' : ''}`}>{formatCurrency(project.overUnder)}</span>
                                <span className="label">Overdue AR:</span>
                                <span className={`value ${project.overdueAR < 0 ? 'positive' : project.overdueAR > 0 ? 'negative' : ''}`}>{formatCurrency(project.overdueAR)}</span>
                                <span className="label">Retainage:</span>
                                <span className={`value`}>{formatCurrency(project.totalRetainage)}</span>
                            </div>
                        </div>

                        {/* Project Team & Customer */}
                        <div className="tooltip-section">
                            <h4>Project Team & Customer</h4>
                            <div className="tooltip-info-grid">
                                <span className="label">Customer:</span>
                                <span className="value">{project.customerName} ({project.customer})</span>
                                <span className="label">Project Manager:</span>
                                <span className="value">{project.projectManagerName}</span>
                                <span className="label">PM Email:</span>
                                <span className="value">{project.projectManagerEmail}</span>
                                <span className="label">PM Phone:</span>
                                <span className="value">{project.projectManagerPhone}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
            <>
            <div 
                className='Project-Component'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => setSelectedProject(project)}
            >
                <div className='Project-Component-Charts-Container' style={chartStyle}>
                    { project && project.revisedBudgetedRevenue > 0 && // REVENUE
                        <div className='Project-Component-Chart'>
                            <div className='Project-Component-Chart-Container'>
                                <div className='Project-Component-Left-Info-Bar'>
                                    { project.overdueAR > 0 && 
                                        <div className='Project-Component-Left-Info-Bar-Overdue'>
                                            {overDueARDisplay}
                                            <FaCommentDollar className='Project-Component-Left-Info-Bar-Overdue-Icon'/>
                                        </div>
                                    }
                                    {   project.projectType === 'Project' &&
                                    <>
                                        <div className='Project-Component-Left-Info-Bar-Under'>
                                            {   (project.requiredAdjustment < 0 || project.requiredAdjustment > 0) &&
                                                <>
                                                    {overUnderDisplay}
                                                    {   project.requiredAdjustment && project.requiredAdjustment > 0 &&
                                                        <ImArrowUp className='Project-Component-Left-Info-Bar-Under-Icon'/>
                                                    }
                                                    {   project.requiredAdjustment && project.requiredAdjustment < 0 &&
                                                        <ImArrowDown className='Project-Component-Left-Info-Bar-Over-Icon'/>
                                                    }
                                                </>
                                            }
                                        </div>
                                    

                                    </>
                                    }
                                </div>  

                                {   project.projectType === 'Project' && project.overUnder > 0 &&
                                    <div className='Project-Component-Adjustment-Bar-Negative'></div>
                                }

                                {   project.projectType === 'Project' && project.overUnder < 0 &&
                                    <div className='Project-Component-Adjustment-Bar-Positive'></div>
                                }

                                <div className='Project-Component-Budgetted-Revenue-Bar'>

                                </div>

                                {   project.projectType === 'Project' &&  project.billingLevel > 0 &&
                                    <div className='Project-Component-Billing-Level' />
                                }
 
                                {   project.actualRevenue > 0 && 
                                <div className='Project-Component-Actual-Revenue-Bar' />
                                }

                                <div className='Project-Component-Values-Bar'>
                                    { (billingLevelDisplay >= actualRevenueDisplay) && project.projectType === 'Project' &&
                                    <>
                                        <div className='Project-Component-Values-Bar-Budgetted-Revenue'>
                                            {budgettedRevenueDisplay}
                                        </div>
                                        { project.projectType === 'Project' && project.billingLevel > 0 &&
                                            <div className='Project-Component-Values-Bar-Billing-Level'>
                                                {billingLevelDisplay}
                                            </div>
                                        }
                                        {   project.actualRevenue > 0 &&
                                            <div className='Project-Component-Values-Bar-Actual-Revenue'>
                                                {actualRevenueDisplay}
                                            </div>
                                        }

                                    </>
                                    }
                                    { billingLevelDisplay < actualRevenueDisplay && project.projectType === 'Project' &&
                                    <>
                                        <div className='Project-Component-Values-Bar-Budgetted-Revenue'>
                                            {budgettedRevenueDisplay}
                                        </div>
                                        {   project.actualRevenue > 0 &&
                                            <div className='Project-Component-Values-Bar-Actual-Revenue-Above-Billing'>
                                                {actualRevenueDisplay}
                                            </div>
                                        }
                                        { project.projectType === 'Project' && project.billingLevel > 0 &&
                                            <div className='Project-Component-Values-Bar-Billing-Level'>
                                                {billingLevelDisplay}
                                            </div>
                                        }
                                    </>
                                    }

                                    { project.projectType !== 'Project' &&
                                    <>
                                        <div className='Project-Component-Values-Bar-Budgetted-Revenue'>
                                            {budgettedRevenueDisplay}
                                        </div>
                                        {   project.actualRevenue > 0 &&
                                            <div className='Project-Component-Values-Bar-Actual-Revenue'>
                                                {actualRevenueDisplay}
                                            </div>
                                        }

                                    </>
                                    }
                                </div>
                            </div>
                        </div>

                    }

                    { project && project.revisedBudgetedCosts > 0 && // COST
                        <div className='Project-Component-Chart'>
                            <div className='Project-Component-Chart-Container'>
                                <div className='Project-Component-Budgetted-Cost-Bar'>

                                </div>

                                {   project.actualCosts > 0 &&
                                    <div className='Project-Component-Actual-Cost-Bar'/>
                                }
                                

                                <div className='Project-Component-Values-Bar'>
                                    <div className='Project-Component-Values-Bar-Budgetted'>
                                        {budgettedCostsDisplay}
                                    </div>

                                    {   project.actualCosts > 0 &&
                                        <div className='Project-Component-Values-Bar-Actual'>
                                            {actualCostsDisplay}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className='Project-Component-Information-Section'> 
                    <div className='Project-Component-Number'>
                        {`${project.projectId}`}
                    </div>
                    <div className='Project-Component-Title'>
                        {`${project.name}`}
                    </div>
                    <div className='Project-Component-Subtitle'>
                        {`${project.customer} - ${project.customerName}`}
                    </div>
                    <div className='Project-Component-Subtitle'>
                        {`${project.projectManagerName}`}
                    </div>
                </div>
            </div>
            <ProjectTooltip />

        </>
    );
};

const ProjectScreen = ({ project, closeProjectScreen }) => {
    if(!project) return null;

    // Helper functions for formatting
    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) return '$0';
        return `$${Math.abs(amount).toLocaleString()}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleDateString();
        } catch {
            return 'Invalid Date';
        }
    };

    const formatPercentage = (value) => {
        if (value === null || value === undefined) return '0%';
        return `${value.toFixed(1)}%`;
    };

    // Calculate project metrics
    const completionPercentage = project.revisedBudgetedCosts > 0 
        ? (project.actualCosts / project.revisedBudgetedCosts) * 100 
        : 0;

    const profitMargin = project.revisedBudgetedRevenue > 0 
        ? ((project.revisedBudgetedRevenue - project.revisedBudgetedCosts) / project.revisedBudgetedRevenue) * 100 
        : 0;

    const actualProfitMargin = project.actualRevenue > 0 
        ? ((project.actualRevenue - project.actualCosts) / project.actualRevenue) * 100 
        : 0;

    // Sort overdue invoices by most overdue (oldest due date first)
    const sortedOverdueInvoices = project.overdueInvoices ? 
        [...project.overdueInvoices]
            .filter(invoice => invoice.status === 'Open' && invoice.balance > 0)
            .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate))
        : [];

    // Sort tasks by task ID
    const sortedTasks = project.tasks ? 
        Object.values(project.tasks).sort((a, b) => a.taskId.localeCompare(b.taskId))
        : [];

    return (
        <div className='Project-Screen-Backdrop' onClick={closeProjectScreen}>
            <div className='Project-Screen-Content' onClick={(e) => e.stopPropagation()}>
                <div className='Project-Screen-Header'>
                    <h2 className='Project-Screen-Title'>{`${project.projectId} - ${project.name}`}</h2>
                    <button 
                        className='Project-Screen-Close-Button' 
                        onClick={closeProjectScreen}
                        aria-label="Close project details"
                    >
                        <IoMdClose />
                    </button>
                </div>
                <div className='Project-Screen-Body'>
                    {/* Basic Project Information */}
                    <div className='Project-Screen-Info-Section'>
                        <h3>Project Information</h3>
                        <div className='Project-Screen-Info-Grid'>
                            <p><strong>Customer:</strong> {project.customerName} ({project.customer})</p>
                            <p><strong>Branch:</strong> {project.branch}</p>
                            <p><strong>Status:</strong> {project.status}</p>
                            <p><strong>Type:</strong> {project.projectType}</p>
                            <p><strong>Start Date:</strong> {formatDate(project.startDate)}</p>
                            <p><strong>Street:</strong> {project.projectAddress.addressLine1}</p>
                            <p><strong>City, State:</strong> {project.projectAddress.city}, {project.projectAddress.state}</p>
                            <p><strong>Country:</strong> {project.projectAddress.country}</p>
                        </div>

                        <div className='Project-Screen-Spacer'/>

                        <h3>Project Team</h3>
                        <div className='Project-Screen-Info-Grid'>
                            <p><strong>Project Manager:</strong> {project.projectManagerName} ({project.projectManager})</p>
                            <p><strong>PM Email:</strong> {project.projectManagerEmail}</p>
                            <p><strong>PM Phone:</strong> {project.projectManagerPhone}</p>
                        </div>

                        <div className='Project-Screen-Spacer'/>

                        <h3>Retainage, Bonds, and Prevailing</h3>
                        <div className='Project-Screen-Info-Grid'>
                            <p><strong>Total Retainage:</strong> {formatCurrency(project.totalRetainage)}</p>
                            <p><strong>Retainage Percentage:</strong> {formatPercentage(project.retainagePercent)}</p>
                            <p><strong>Stepped Retainage:</strong> {project.steppedRetainage ? 'Yes' : 'No'}</p>
                            <p><strong>Bond Required:</strong> {project.bondRequired}</p>
                            <p><strong>Bond Received:</strong> {project.bondReceived}</p>
                            <p><strong>Prevailing Wage:</strong> {project.prevailingWage}</p>
                        </div>
                    </div>

                    {/* Financial Summary */}
                    <div className='Project-Screen-Financial-Section'>
                        <h3>Financial Summary</h3>
                        <div className='Project-Screen-Financial-Grid'>
                            <div className='Financial-Column'>
                                <h4>Revenue</h4>
                                <p><strong>Original Contract Amount:</strong> {formatCurrency(project.contractAmount)}</p>
                                <p><strong>Original Budgeted Revenue:</strong> {formatCurrency(project.originalBudgetedRevenue)}</p>
                                <p><strong>Revised Budgeted Revenue:</strong> {formatCurrency(project.revisedBudgetedRevenue)}</p>
                                <p><strong>Actual Revenue:</strong>                                     
                                    <span className={project.overUnder > 0 ? 'positive' : project.overUnder < 0 ? 'negative' : ''}>
                                        {formatPercentage(actualProfitMargin)}
                                    </span></p>
                                <p><strong>Billing Level:</strong> {formatCurrency(project.billingLevel)}</p>
                            </div>
                            <div className='Financial-Column'>
                                <h4>Costs</h4>
                                <p><strong>Original Budgeted Costs:</strong> {formatCurrency(project.originalBudgetedCosts)}</p>
                                <p><strong>Revised Budgeted Costs:</strong> {formatCurrency(project.revisedBudgetedCosts)}</p>
                                <p><strong>Actual Costs:</strong> {formatCurrency(project.actualCosts)}</p>
                                <p><strong>Expenses:</strong> {formatCurrency(project.expenses)}</p>
                            </div>
                            <div className='Financial-Column'>
                                <h4>Performance</h4>
                                <p><strong>Over/Under:</strong> 
                                    <span className={project.overUnder >= 0 ? 'neutral' : 'negative'}>
                                        {project.overUnder >= 0 ? '+' : '-'}{formatCurrency(project.overUnder)}
                                    </span>
                                </p>
                                <p><strong>Required Adjustment:</strong> {formatCurrency(project.requiredAdjustment)}</p>
                                <p><strong>Budgeted Profit Margin:</strong> {formatPercentage(profitMargin)}</p>
                                <p><strong>Actual Profit Margin:</strong> 
                                    <span className={actualProfitMargin > profitMargin ? 'positive' : actualProfitMargin <= 0 && project.overUnder < 0 ? 'negative' : actualProfitMargin > profitMargin && actualProfitMargin > 0 ? 'neutral' : ''}>
                                        {formatPercentage(actualProfitMargin)}
                                    </span>
                                </p>
                                <p><strong>Completion:</strong> {formatPercentage(completionPercentage)}</p>
                            </div>
                        </div>
                    </div>

                    {
                        /*

                        */
                    }

                    {/* Overdue Invoices */}
                    {sortedOverdueInvoices.length > 0 && (
                        <div className='Project-Screen-Invoices-Section'>
                            <h3>Overdue Invoices <span className='overdue-count'>({sortedOverdueInvoices.length})</span></h3>
                            <p><strong>Total Overdue AR:</strong> 
                                <span className='negative'>{formatCurrency(project.overdueAR)}</span>
                            </p>
                            <div className='Invoices-Table'>
                                <div className='Invoice-Header'>
                                    <span>Invoice #</span>
                                    <span>Due Date</span>
                                    <span>Amount</span>
                                    <span>Balance</span>
                                    <span>Days Overdue</span>
                                </div>
                                {sortedOverdueInvoices.map((invoice, index) => {
                                    const daysOverdue = Math.floor((new Date() - new Date(invoice.dueDate)) / (1000 * 60 * 60 * 24));
                                    return (
                                        <div key={index} className={`Invoice-Row ${daysOverdue > 90 ? 'severely-overdue' : daysOverdue > 30 ? 'moderately-overdue' : 'recently-overdue'}`}>
                                            <span>{invoice.invoiceNumber}</span>
                                            <span>{formatDate(invoice.dueDate)}</span>
                                            <span>{formatCurrency(invoice.amount)}</span>
                                            <span>{formatCurrency(invoice.balance)}</span>
                                            <span className='days-overdue'>{daysOverdue} days</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Tasks Breakdown */}
                    {sortedTasks.length > 0 && (
                        <div className='Project-Screen-Tasks-Section'>
                            <h3>Task Breakdown</h3>
                            <div className='Tasks-Table'>
                                <div className='Task-Header'>
                                    <span>Task ID</span>
                                    <span>Original Budget</span>
                                    <span>Change Orders</span>
                                    <span>Revised Budget</span>
                                </div>
                                {sortedTasks.map((task, index) => (
                                    <div key={index} className='Task-Row'>
                                        <span>{task.taskId}</span>
                                        <span>{formatCurrency(task.originalBudgettedAmount)}</span>
                                        <span className={task.changeOrderAmount !== 0 ? (task.changeOrderAmount > 0 ? 'positive' : 'negative') : ''}>
                                            {task.changeOrderAmount !== 0 ? (task.changeOrderAmount > 0 ? '+' : '') + formatCurrency(task.changeOrderAmount) : '-'}
                                        </span>
                                        <span>{formatCurrency(task.RevisedBudgetedAmount)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};

const ProjectSection = ({ groupDetails, setSelectedProject }) => {
    const [expanded, setExpanded] = useState(true);

    return (
        <div className='Project-Dashboard-Section' >
            <div className='Project-Dashboard-Section-Header-Modern'>
                <div className='Project-Dashboard-Section-Header-Left'>
                    <div className='Project-Dashboard-Section-Expand-Icon-Modern' onClick={() => setExpanded(!expanded)}>
                        { expanded ? <IoMdArrowDropdown /> : <IoMdArrowDropright /> }
                    </div>
                    <h2 className='Project-Dashboard-Section-Title-Modern'>
                        {`${groupDetails.id} - ${groupDetails.name}`}
                    </h2>
                    <div className='Project-Dashboard-Section-Count-Badge'>
                        {groupDetails.totalProjects}
                    </div>
                </div>
                
                <div className='Project-Dashboard-Section-Stats-Modern'>
                    <div className='Project-Dashboard-Section-Stat-Modern'>
                        <div className='stat-value-modern open'>{groupDetails.openProjects}</div>
                        <div className='stat-label-modern'>Open</div>
                    </div>
                    <div className='Project-Dashboard-Section-Stat-Modern'>
                        <div className='stat-value-modern closed'>{groupDetails.closedProjects}</div>
                        <div className='stat-label-modern'>Closed</div>
                    </div>
                    <div className='Project-Dashboard-Section-Stat-Modern'>
                        <div className={`stat-value-modern ${groupDetails.overdueAR <= 0 ? 'positive' : 'negative'}`}>
                            ${groupDetails.overdueAR?.toLocaleString()}
                        </div>
                        <div className='stat-label-modern'>Overdue AR</div>
                    </div>
                    <div className='Project-Dashboard-Section-Stat-Modern'>
                        <div className={`stat-value-modern ${groupDetails.overUnder >= 0 ? 'positive' : 'negative'}`}>
                            ${groupDetails.overUnder?.toLocaleString()}
                        </div>
                        <div className='stat-label-modern'>Over/Under</div>
                    </div>
                </div>
            </div>
            { expanded &&
                <div className='Project-Dashboard-Section-Content'>
                    {
                    Object.keys(groupDetails.projects)
                        .sort((a, b) => Number(a) - Number(b))
                        .map(projectId => (
                        <div key={projectId}>
                            <ProjectComponent project={groupDetails.projects[projectId]} setSelectedProject={setSelectedProject}/>
                        </div>
                    ))
                    }
                </div>
            }
        </div>
    )
};

const ProjectsDashboard = ({projectsList}) => {
    const [ selectedProject, setSelectedProject ] = useState(null);

    const closeProjectScreen = () => {
        setSelectedProject(null);
    };

    return (
        <div className='Projects-Dashboard'>
            {   selectedProject &&
                <ProjectScreen project={selectedProject} closeProjectScreen={closeProjectScreen}/>
            }
            {   projectsList &&
            <>
                {/* Iterate through branches */}
                {Object.keys(projectsList)
                    .sort((a, b) => Number(a) - Number(b))
                    .map(branchId => {
                        const branch = projectsList[branchId];
                        
                        // Collect all projects from all project managers in this branch
                        const allBranchProjects = {};
                        if (branch.projectManagers) {
                            Object.values(branch.projectManagers).forEach(pm => {
                                if (pm.projects) {
                                    Object.assign(allBranchProjects, pm.projects);
                                }
                            });
                        }
                        
                        return (
                            <div key={branchId}>
                                {/* Branch Section with all projects */}
                                <ProjectSection 
                                    groupDetails={{
                                        id: branch.id,
                                        name: branch.name,
                                        totalProjects: branch.totalProjects,
                                        openProjects: branch.openProjects,
                                        closedProjects: branch.closedProjects,
                                        overdueAR: branch.overdueAR,
                                        overUnder: branch.overUnder,
                                        projects: allBranchProjects
                                    }} 
                                    setSelectedProject={setSelectedProject}
                                />
                            </div>
                        );
                    })
                }
            </>
            }
            
        </div>
    );
};

const LaborEquipmentDashboard = ({procoreLaborList, fieldServiceLaborList, completeTechList, weeklyRequests, projectRequests, titles, projects, accessToken}) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedEmployees, setSelectedEmployees] = useState({});
    const [titleFilter, setTitleFilter] = useState([]);
    const [branchFilter, setBranchFilter] = useState([]); // Changed from projectFilter to branchFilter
    const [pmFilter, setPmFilter] = useState([]); // New: filter for project managers
    const [nameSearch, setNameSearch] = useState('');
    const [projectSearch, setProjectSearch] = useState('');
    const [titleDropdownOpen, setTitleDropdownOpen] = useState(false);
    const [branchDropdownOpen, setBranchDropdownOpen] = useState(false); // Changed from projectDropdownOpen
    const [viewMode, setViewMode] = useState('title'); // 'title' or 'project'
    const [periodMode, setPeriodMode] = useState('week'); // 'week' or 'month'
    const [requestDetailsModal, setRequestDetailsModal] = useState({
        isOpen: false,
        title: '',
        weekKey: '',
        projects: []
    });
    
    // Saved Views State
    const [savedViews, setSavedViews] = useState([]);
    const [selectedView, setSelectedView] = useState(null);
    const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewModalMode, setViewModalMode] = useState('create'); // 'create' or 'edit'
    const [editingView, setEditingView] = useState(null);
    const [viewFormData, setViewFormData] = useState({ name: '', titles: [] });

    // Load saved views on component mount
    useEffect(() => {
        if (accessToken) {
            loadSavedViews();
        }
    }, [accessToken]);

    // Function to load saved views from backend
    const loadSavedViews = () => {
        getLEViews(
            accessToken,
            (data) => {
                if (data && Array.isArray(data)) {
                    setSavedViews(data);
                }
            },
            (error) => {
                console.error('Error loading views:', error);
            }
        );
    };

    // Transform completeTechList into technician employees array
    const transformTechnicians = () => {
        if (!completeTechList) return [];
        
        return Object.values(completeTechList).map(tech => {
            // Extract branch from employeeSettings or default to unknown branch
            const branchID = tech.employeeSettings?.branchID || 'XX';
            const title = `${branchID} - Service Tech`;
            
            // Get appointments for this technician from fieldServiceLaborList
            const techAppointments = fieldServiceLaborList && fieldServiceLaborList[tech.employeeID] 
                ? fieldServiceLaborList[tech.employeeID].appointments 
                : {};

            // Transform appointments to match the expected format
            const appointments = Object.values(techAppointments || {}).map(appointment => {
                // Convert scheduled dates to work days array (assuming daily work for simplicity)
                const startDate = new Date(appointment.scheduledStartDate);
                const endDate = new Date(appointment.scheduledEndDate);
                const workDays = [false, true, true, true, true, true, false]; // Default: Mon-Fri
                
                // Parse time from scheduled dates
                const startTime = startDate.toLocaleTimeString('en-US', { 
                    hour: 'numeric', 
                    minute: '2-digit', 
                    hour12: true 
                });
                const endTime = new Date(appointment.scheduledEndDate).toLocaleTimeString('en-US', { 
                    hour: 'numeric', 
                    minute: '2-digit', 
                    hour12: true 
                });

                return {
                    appointmentID: appointment.appointmentID,
                    projectNumber: appointment.orderNbr || 'N/A',
                    projectName: appointment.description || 'Service Call',
                    startDay: appointment.scheduledStartDate,
                    endDay: appointment.scheduledEndDate,
                    startTime: startTime,
                    endTime: endTime,
                    workDays: workDays,
                    percentAllocated: null, // Field service typically doesn't have partial allocation
                    workScopeText: appointment.description || 'Field Service',
                    location: appointment.location,
                    customerName: appointment.customerName,
                    status: appointment.status
                };
            });

            return {
                employeeId: tech.employeeID,
                name: tech.employeeName,
                title: title,
                appointments: appointments,
                color: '#2563eb', // Blue color for technicians to distinguish from regular labor
                branch: branchID,
                type: 'technician'
            };
        });
    };

    // Group employees by title
    const groupEmployeesByTitle = (employeesArray) => {
        if (!employeesArray || !Array.isArray(employeesArray)) return {};
        
        const grouped = employeesArray.reduce((acc, employee) => {
            const title = employee.title || 'Unknown Role';
            if (!acc[title]) {
                acc[title] = [];
            }
            acc[title].push(employee);
            return acc;
        }, {});
        
        // Sort employees within each title group by name
        Object.keys(grouped).forEach(title => {
            grouped[title].sort((a, b) => 
                (a.name || '').localeCompare(b.name || '')
            );
        });
        
        return grouped;
    };

    // Generate calendar dates for multiple weeks (now showing weeks instead of days)
    const getWeekDates = () => {
        const weeks = [];
        const startDate = new Date(currentDate);
        
        // Get start of current week (Sunday)
        const dayOfWeek = startDate.getDay();
        startDate.setDate(startDate.getDate() - dayOfWeek);
        
        // Generate 10 weeks (current week + 9 future weeks)
        for (let i = 0; i < 10; i++) {
            const weekStart = new Date(startDate);
            weekStart.setDate(startDate.getDate() + (i * 7));
            weeks.push(weekStart);
        }
        
        return weeks;
    };

    // Generate calendar dates for months
    const getMonthDates = () => {
        const months = [];
        const startDate = new Date(currentDate);
        
        // Get start of current month
        const monthStart = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        
        // Generate 10 months (current month + 9 future months)
        for (let i = 0; i < 10; i++) {
            const month = new Date(monthStart.getFullYear(), monthStart.getMonth() + i, 1);
            months.push(month);
        }
        
        return months;
    };

    // Get the highest request count for a title in a given month
    const getMaxRequestsForMonth = (title, monthStart) => {
        if (!weeklyRequests) return 0;
        
        let maxRequests = 0;
        const monthEnd = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0);
        
        // Iterate through all weeks in the month
        Object.keys(weeklyRequests).forEach(weekKey => {
            const [month, day, year] = weekKey.split('/').map(Number);
            const weekDate = new Date(year, month - 1, day);
            
            // Check if this week falls within the month
            if (weekDate >= monthStart && weekDate <= monthEnd) {
                const requestCount = weeklyRequests[weekKey]?.[title] || 0;
                maxRequests = Math.max(maxRequests, requestCount);
            }
        });
        
        return maxRequests;
    };

    // Get projects for a specific employee and month
    const getProjectsForMonth = (employee, monthStart) => {
        if (!employee.appointments || !Array.isArray(employee.appointments)) {
            return [];
        }

        const projects = [];
        const monthEnd = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0);
        
        employee.appointments.forEach(appointment => {
            const appointmentStart = new Date(appointment.startDay);
            const appointmentEnd = new Date(appointment.endDay);
            
            // Check if appointment overlaps with this month
            const overlapsMonth = appointmentStart <= monthEnd && appointmentEnd >= monthStart;
            
            if (overlapsMonth) {
                projects.push(appointment);
            }
        });

        return projects;
    };

    // Navigation functions (now navigate by weeks instead of days)
    const navigatePrevious = () => {
        const newDate = new Date(currentDate);
        if (periodMode === 'month') {
            // Go back 3 months
            newDate.setMonth(newDate.getMonth() - 3);
        } else {
            // Go back 4 weeks
            newDate.setDate(newDate.getDate() - 28);
        }
        setCurrentDate(newDate);
    };

    const navigateNext = () => {
        const newDate = new Date(currentDate);
        if (periodMode === 'month') {
            // Go forward 3 months
            newDate.setMonth(newDate.getMonth() + 3);
        } else {
            // Go forward 4 weeks
            newDate.setDate(newDate.getDate() + 28);
        }
        setCurrentDate(newDate);
    };

    const navigateToday = () => {
        setCurrentDate(new Date());
    };

    // Quick selector for jumping to specific weeks/months
    const jumpToDate = (targetDate) => {
        setCurrentDate(new Date(targetDate));
    };

    // Generate quick selector options for jumping to different months
    const getQuickSelectorOptions = () => {
        const options = [];
        const today = new Date();
        
        // Generate next 12 months, jumping to first week of each month
        for (let i = 0; i < 12; i++) {
            const monthStart = new Date(today.getFullYear(), today.getMonth() + i, 1);
            // Find the first Sunday of the month (or the Sunday before if month doesn't start on Sunday)
            const firstWeekStart = new Date(monthStart);
            firstWeekStart.setDate(monthStart.getDate() - monthStart.getDay());
            
            options.push({
                value: firstWeekStart.toISOString(),
                label: monthStart.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }),
                date: firstWeekStart
            });
        }
        
        return options;
    };

    // Format date for display (now shows week starting date only)
    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric',
            year: 'numeric'
        });
    };

    // Get current week range string
    const getCurrentWeekString = () => {
        if (periodMode === 'month') {
            const months = getMonthDates();
            const start = months[0];
            const lastMonth = months[months.length - 1];
            return `${start.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })} - ${lastMonth.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`;
        } else {
            const weeks = getWeekDates();
            const start = weeks[0];
            const lastWeek = weeks[weeks.length - 1];
            const end = new Date(lastWeek);
            end.setDate(end.getDate() + 6); // End of last week
            return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
        }
    };

    // Get projects for a specific employee and week
    const getProjectsForWeek = (employee, weekStartDate) => {
        if (!employee.appointments || !Array.isArray(employee.appointments)) {
            return [];
        }

        const projects = [];
        const weekStart = new Date(weekStartDate.getFullYear(), weekStartDate.getMonth(), weekStartDate.getDate());
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekEnd.getDate() + 6); // End of week (Saturday)
        
        employee.appointments.forEach(appointment => {
            const appointmentStart = new Date(appointment.startDay);
            const appointmentEnd = new Date(appointment.endDay);
            
            // Create date objects for comparison (set to midnight to compare dates only)
            const projectStartDate = new Date(appointmentStart.getFullYear(), appointmentStart.getMonth(), appointmentStart.getDate());
            const projectEndDate = new Date(appointmentEnd.getFullYear(), appointmentEnd.getMonth(), appointmentEnd.getDate());
            
            // Check if appointment overlaps with this week
            const overlapsWeek = projectStartDate <= weekEnd && projectEndDate >= weekStart;
            
            if (overlapsWeek) {
                // Check if there are any work days in this week for this appointment
                let hasWorkDaysInWeek = false;
                for (let i = 0; i < 7; i++) {
                    const checkDate = new Date(weekStart);
                    checkDate.setDate(checkDate.getDate() + i);
                    const dayOfWeek = checkDate.getDay();
                    
                    // Check if this day is within the appointment period and is a work day
                    if (checkDate >= projectStartDate && checkDate <= projectEndDate && 
                        appointment.workDays && appointment.workDays[dayOfWeek]) {
                        hasWorkDaysInWeek = true;
                        break;
                    }
                }
                
                if (hasWorkDaysInWeek) {
                    projects.push(appointment);
                }
            }
        });

        return projects;
    };

    // Format project time for display
    const formatProjectTime = (startTime, endTime) => {
        if (!startTime || !endTime) return 'All Day';
        return `${startTime} - ${endTime}`;
    };

    // Format work days for display
    const formatWorkDays = (workDays) => {
        if (!workDays) return 'N/A';
        
        const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const workingDays = [];
        
        // Handle work_days object structure with string keys "0", "1", etc.
        for (let i = 0; i < 7; i++) {
            if (workDays[i.toString()] === true) {
                workingDays.push(dayNames[i]);
            }
        }
        
        if (workingDays.length === 0) return 'No work days';
        if (workingDays.length === 7) return 'Every day';
        
        // Check for common patterns
        const isWeekdays = workingDays.length === 5 && 
            ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].every(day => workingDays.includes(day));
        
        if (isWeekdays) return 'Mon - Fri';
        
        // Check for consecutive days
        if (workingDays.length > 2) {
            const firstDay = workingDays[0];
            const lastDay = workingDays[workingDays.length - 1];
            const firstIndex = dayNames.indexOf(firstDay);
            const lastIndex = dayNames.indexOf(lastDay);
            
            // Check if it's a consecutive range
            let isConsecutive = true;
            for (let i = firstIndex; i <= lastIndex; i++) {
                if (!workingDays.includes(dayNames[i])) {
                    isConsecutive = false;
                    break;
                }
            }
            
            if (isConsecutive && workingDays.length === (lastIndex - firstIndex + 1)) {
                return `${firstDay} - ${lastDay}`;
            }
        }
        
        return workingDays.join(', ');
    };

    // Handle opening the request details modal
    const handleRequestClick = (title, weekKey, projectNumber = null) => {
        // Get all projects that have requests for this title and week
        const projectsForRequest = [];
        
        // If projectNumber is provided (from project view), only show that project
        if (projectNumber) {
            const projectWeeks = projectRequests?.[projectNumber];
            const requestCount = projectWeeks?.[weekKey]?.[title] || 0;
            
            if (requestCount > 0) {
                const projectDetail = projects?.find(p => p.number === projectNumber);
                if (projectDetail) {
                    projectsForRequest.push({
                        ...projectDetail,
                        requestedCount: requestCount
                    });
                }
            }
        } else {
            // Original behavior for title view - search all projects
            if (projectRequests) {
                Object.keys(projectRequests).forEach(projNum => {
                    const projectWeeks = projectRequests[projNum];
                    if (projectWeeks && projectWeeks[weekKey] && projectWeeks[weekKey][title]) {
                        // Find the project details from the projects array
                        const projectDetail = projects?.find(p => p.number === projNum);
                        if (projectDetail) {
                            projectsForRequest.push({
                                ...projectDetail,
                                requestedCount: projectWeeks[weekKey][title]
                            });
                        }
                    }
                });
            }
        }
        
        const totalRequestCount = projectsForRequest.reduce((sum, proj) => sum + proj.requestedCount, 0);
        
        setRequestDetailsModal({
            isOpen: true,
            title: title,
            weekKey: weekKey,
            requestCount: totalRequestCount,
            projects: projectsForRequest
        });
    };

    // Generate month headers for the weeks
    const getMonthHeaders = () => {
        if (periodMode === 'month') {
            // In month mode, each column is a month, so return months directly
            const months = getMonthDates();
            return months.map((monthStart, index) => ({
                month: monthStart.toLocaleDateString('en-US', { 
                    month: 'long', 
                    year: 'numeric' 
                }),
                span: 1,
                startIndex: index
            }));
        }
        
        // In week mode, group weeks by month
        const weeks = getWeekDates();
        const monthHeaders = [];
        let currentMonth = null;
        let monthSpan = 0;

        weeks.forEach((weekStart, index) => {
            const monthYear = weekStart.toLocaleDateString('en-US', { 
                month: 'long', 
                year: 'numeric' 
            });

            if (currentMonth !== monthYear) {
                if (currentMonth !== null) {
                    monthHeaders.push({
                        month: currentMonth,
                        span: monthSpan,
                        startIndex: index - monthSpan
                    });
                }
                currentMonth = monthYear;
                monthSpan = 1;
            } else {
                monthSpan++;
            }

            // Handle last month
            if (index === weeks.length - 1) {
                monthHeaders.push({
                    month: currentMonth,
                    span: monthSpan,
                    startIndex: index - monthSpan + 1
                });
            }
        });

        return monthHeaders;
    };

    // Toggle employee selection for detailed view
    const toggleEmployeeSelection = (employeeId) => {
        setSelectedEmployees(prev => ({
            ...prev,
            [employeeId]: !prev[employeeId]
        }));
    };

    // Filter and search employees (including technicians)
    const filterEmployees = (employeesArray) => {
        if (!employeesArray || !Array.isArray(employeesArray)) return [];
        
        return employeesArray.filter(employee => {
            // Filter by title - now supports multiple titles
            const titleMatch = titleFilter.length === 0 || titleFilter.some(selectedTitle => 
                employee.title?.toLowerCase().includes(selectedTitle.toLowerCase())
            );
            
            // Filter by name search
            const nameMatch = !nameSearch || employee.name?.toLowerCase().includes(nameSearch.toLowerCase());
            
            return titleMatch && nameMatch;
        });
    };

    // Toggle title selection
    const toggleTitleSelection = (title) => {
        setTitleFilter(prev => {
            if (prev.includes(title)) {
                return prev.filter(t => t !== title);
            } else {
                return [...prev, title];
            }
        });
    };

    // Clear all title filters
    const clearAllTitleFilters = () => {
        clearSelectedView();
    };

    // Toggle branch selection
    const toggleBranchSelection = (branchId) => {
        setBranchFilter(prev => {
            if (prev.includes(branchId)) {
                return prev.filter(b => b !== branchId);
            } else {
                return [...prev, branchId];
            }
        });
    };

    // Toggle project manager selection
    const togglePMSelection = (branchId, pmName) => {
        const pmKey = `${branchId}|${pmName}`;
        setPmFilter(prev => {
            if (prev.includes(pmKey)) {
                return prev.filter(p => p !== pmKey);
            } else {
                return [...prev, pmKey];
            }
        });
    };

    // Clear all branch and PM filters
    const clearAllBranchFilters = () => {
        setBranchFilter([]);
        setPmFilter([]);
    };

    // Saved Views Functions
    const openCreateViewModal = () => {
        setViewModalMode('create');
        setViewFormData({ name: '', titles: [...titleFilter] });
        setEditingView(null);
        setViewModalOpen(true);
    };

    const openEditViewModal = (view) => {
        setViewModalMode('edit');
        setViewFormData({ name: view.name, titles: [...view.titles] });
        setEditingView(view);
        setViewModalOpen(true);
    };

    const closeViewModal = () => {
        setViewModalOpen(false);
        setViewFormData({ name: '', titles: [] });
        setEditingView(null);
    };

    const saveView = () => {
        if (!viewFormData.name.trim()) {
            alert('Please enter a view name');
            return;
        }

        if (viewModalMode === 'create') {
            const newView = {
                name: viewFormData.name.trim(),
                titles: [...viewFormData.titles]
            };
            
            createLEViews(
                accessToken,
                newView,
                (data) => {
                    closeViewModal();
                    loadSavedViews(); // Reload all views
                },
                (error) => {
                    console.error('Error creating view:', error);
                    alert('Failed to create view. Please try again.');
                }
            );
        } else if (viewModalMode === 'edit' && editingView) {
            const updatedView = {
                id: editingView.id,
                name: viewFormData.name.trim(),
                titles: [...viewFormData.titles]
            };
            
            updateLEViews(
                accessToken,
                updatedView,
                (data) => {
                    closeViewModal();
                    loadSavedViews(); // Reload all views
                },
                (error) => {
                    console.error('Error updating view:', error);
                    alert('Failed to update view. Please try again.');
                }
            );
        }
    };

    const deleteView = (viewId) => {
        if (window.confirm('Are you sure you want to delete this view?')) {
            deleteLEView(
                accessToken,
                viewId,
                (data) => {
                    if (selectedView?.id === viewId) {
                        setSelectedView(null);
                        setTitleFilter([]);
                    }
                    loadSavedViews(); // Reload all views
                },
                (error) => {
                    console.error('Error deleting view:', error);
                    alert('Failed to delete view. Please try again.');
                }
            );
        }
    };

    const applyView = (view) => {
        setSelectedView(view);
        setTitleFilter([...view.titles]);
        setViewDropdownOpen(false);
    };

    const clearSelectedView = () => {
        setSelectedView(null);
        setTitleFilter([]);
    };

    const toggleViewTitleSelection = (title) => {
        setViewFormData(prev => ({
            ...prev,
            titles: prev.titles.includes(title)
                ? prev.titles.filter(t => t !== title)
                : [...prev.titles, title]
        }));
    };

    // Handle clicking outside dropdown to close it
    const handleClickOutside = (event) => {
        if (!event.target.closest('.labor-filter-dropdown-container')) {
            setTitleDropdownOpen(false);
            setBranchDropdownOpen(false);
            setViewDropdownOpen(false);
        }
    };

    // Add event listener for clicking outside
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const weekDates = getWeekDates(); // Now contains week start dates instead of daily dates
    const monthDates = getMonthDates(); // Contains month start dates
    const periodDates = periodMode === 'month' ? monthDates : weekDates; // Use appropriate dates based on mode
    
    // Prepare employees list from procoreLaborList - extract the labor array
    const employees = procoreLaborList?.labor || [];
    const subcontractors = procoreLaborList?.subcontractor || [];
    
    // Get technicians from completeTechList
    const technicians = transformTechnicians();

    // Get all available titles for the dropdown AND for displaying all title groups
    const getAllTitles = () => {
        const allEmployees = [...(employees || []), ...(subcontractors || []), ...(technicians || [])];
        const employeeTitles = [...new Set(allEmployees.map(emp => emp.title).filter(Boolean))];
        
        // Get all titles from the titles array (from API)
        const apiTitles = titles && Array.isArray(titles) ? titles.map(title => title.name) : [];
        
        // Combine both sources and remove duplicates
        const combinedTitles = [...new Set([...employeeTitles, ...apiTitles])];
        return combinedTitles.sort();
    };

    // Get title color from the titles array
    const getTitleColor = (titleName) => {
        if (!titles || !Array.isArray(titles)) return null;
        const titleObj = titles.find(t => t.name === titleName);
        return titleObj ? titleObj.color : null;
    };

    // Create a comprehensive list of all titles with their employees and colors
    const getAllTitleGroups = () => {
        const allTitles = getAllTitles();
        const titleGroups = {};

        // Initialize all titles from API with colors
        allTitles.forEach(titleName => {
            titleGroups[titleName] = {
                employees: [],
                subcontractors: [],
                technicians: [],
                color: getTitleColor(titleName),
                totalCount: 0,
                isServiceTech: titleName.includes('Service Tech') // Flag to identify service tech titles
            };
        });

        // Add filtered employees to their respective title groups
        filteredEmployees.forEach(employee => {
            const title = employee.title || 'Unknown Role';
            if (!titleGroups[title]) {
                titleGroups[title] = {
                    employees: [],
                    subcontractors: [],
                    technicians: [],
                    color: getTitleColor(title),
                    totalCount: 0,
                    isServiceTech: title.includes('Service Tech')
                };
            }
            titleGroups[title].employees.push(employee);
            titleGroups[title].totalCount++;
        });

        // Add filtered subcontractors to their respective title groups
        filteredSubcontractors.forEach(subcontractor => {
            const title = subcontractor.title || 'Unknown Role';
            if (!titleGroups[title]) {
                titleGroups[title] = {
                    employees: [],
                    subcontractors: [],
                    technicians: [],
                    color: getTitleColor(title),
                    totalCount: 0,
                    isServiceTech: title.includes('Service Tech')
                };
            }
            titleGroups[title].subcontractors.push(subcontractor);
            titleGroups[title].totalCount++;
        });

        // Add filtered technicians to their respective title groups
        filteredTechnicians.forEach(technician => {
            const title = technician.title || 'Unknown Role';
            if (!titleGroups[title]) {
                titleGroups[title] = {
                    employees: [],
                    subcontractors: [],
                    technicians: [],
                    color: getTitleColor(title),
                    totalCount: 0,
                    isServiceTech: title.includes('Service Tech')
                };
            }
            titleGroups[title].technicians.push(technician);
            titleGroups[title].totalCount++;
        });

        // Sort employees within each group by name
        Object.keys(titleGroups).forEach(title => {
            titleGroups[title].employees.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            titleGroups[title].subcontractors.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            titleGroups[title].technicians.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        });

        return titleGroups;
    };

    // Create a comprehensive list of all projects with their employees, grouped by branch and project manager
    const getAllProjectGroups = () => {
        if (!projects || !Array.isArray(projects)) return {};
        
        const branchGroups = {};
        const allEmployees = [...(filteredEmployees || []), ...(filteredSubcontractors || []), ...(filteredTechnicians || [])];
        
        // Initialize project groups for active projects, grouped by branch -> project manager -> project
        projects.filter(project => project.status === 'active').forEach(project => {
            const branch = project.branch || 'Unknown Branch';
            const projectManager = project.projectManager || 'Unknown PM';
            
            // Initialize branch if it doesn't exist
            if (!branchGroups[branch]) {
                branchGroups[branch] = {
                    branchId: branch,
                    projectManagers: {}
                };
            }
            
            // Initialize project manager if it doesn't exist
            if (!branchGroups[branch].projectManagers[projectManager]) {
                branchGroups[branch].projectManagers[projectManager] = {
                    name: projectManager,
                    projects: {}
                };
            }
            
            // Initialize project
            branchGroups[branch].projectManagers[projectManager].projects[project.number] = {
                name: project.name,
                number: project.number,
                color: project.color,
                startDate: project.startDate,
                endDate: project.endDate,
                branch: branch,
                projectManager: projectManager,
                employees: [],
                totalCount: 0
            };
        });
        
        // Also add projects from projectRequests that have requests but may not be in active projects yet
        if (projectRequests) {
            Object.keys(projectRequests).forEach(projectNumber => {
                // Find project details from the projects array
                const projectDetail = projects.find(p => p.number === projectNumber);
                if (projectDetail) {
                    const branch = projectDetail.branch || 'Unknown Branch';
                    const projectManager = projectDetail.projectManager || 'Unknown PM';
                    
                    // Initialize branch if it doesn't exist
                    if (!branchGroups[branch]) {
                        branchGroups[branch] = {
                            branchId: branch,
                            projectManagers: {}
                        };
                    }
                    
                    // Initialize project manager if it doesn't exist
                    if (!branchGroups[branch].projectManagers[projectManager]) {
                        branchGroups[branch].projectManagers[projectManager] = {
                            name: projectManager,
                            projects: {}
                        };
                    }
                    
                    // Initialize project if it doesn't exist
                    if (!branchGroups[branch].projectManagers[projectManager].projects[projectNumber]) {
                        branchGroups[branch].projectManagers[projectManager].projects[projectNumber] = {
                            name: projectDetail.name,
                            number: projectDetail.number,
                            color: projectDetail.color,
                            startDate: projectDetail.startDate,
                            endDate: projectDetail.endDate,
                            branch: branch,
                            projectManager: projectManager,
                            employees: [],
                            totalCount: 0
                        };
                    }
                }
            });
        }
        
        // Assign employees to projects based on their appointments
        allEmployees.forEach(employee => {
            if (employee.appointments && Array.isArray(employee.appointments)) {
                employee.appointments.forEach(appointment => {
                    const projectNumber = appointment.projectNumber;
                    
                    // Find the project across all branches and project managers
                    Object.values(branchGroups).forEach(branchGroup => {
                        Object.values(branchGroup.projectManagers).forEach(pmGroup => {
                            if (pmGroup.projects[projectNumber]) {
                                // Check if this employee is already in the project group
                                const alreadyAdded = pmGroup.projects[projectNumber].employees.some(
                                    emp => emp.employeeId === employee.employeeId
                                );
                                if (!alreadyAdded) {
                                    pmGroup.projects[projectNumber].employees.push(employee);
                                    pmGroup.projects[projectNumber].totalCount++;
                                }
                            }
                        });
                    });
                });
            }
        });
        
        // Sort employees within each project by name
        Object.values(branchGroups).forEach(branchGroup => {
            Object.values(branchGroup.projectManagers).forEach(pmGroup => {
                Object.values(pmGroup.projects).forEach(project => {
                    project.employees.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                });
            });
        });
        
        // Remove empty projects, project managers, and branches
        Object.keys(branchGroups).forEach(branch => {
            Object.keys(branchGroups[branch].projectManagers).forEach(pm => {
                Object.keys(branchGroups[branch].projectManagers[pm].projects).forEach(projectNumber => {
                    const project = branchGroups[branch].projectManagers[pm].projects[projectNumber];
                    const hasEmployees = project.totalCount > 0;
                    const hasRequests = projectRequests?.[projectNumber] && 
                        Object.keys(projectRequests[projectNumber]).length > 0;
                    
                    if (!hasEmployees && !hasRequests) {
                        delete branchGroups[branch].projectManagers[pm].projects[projectNumber];
                    }
                });
                
                // Remove project manager if no projects
                if (Object.keys(branchGroups[branch].projectManagers[pm].projects).length === 0) {
                    delete branchGroups[branch].projectManagers[pm];
                }
            });
            
            // Remove branch if no project managers
            if (Object.keys(branchGroups[branch].projectManagers).length === 0) {
                delete branchGroups[branch];
            }
        });
        
        return branchGroups;
    };

    // Apply filters to employees, subcontractors, and technicians
    const filteredEmployees = filterEmployees(employees);
    const filteredSubcontractors = filterEmployees(subcontractors);
    const filteredTechnicians = filterEmployees(technicians);
    
    // Group filtered employees, subcontractors, and technicians by title
    const groupedEmployees = groupEmployeesByTitle(filteredEmployees);
    const groupedSubcontractors = groupEmployeesByTitle(filteredSubcontractors);
    const groupedTechnicians = groupEmployeesByTitle(filteredTechnicians);

    // Get all available titles for the dropdown
    const availableTitles = getAllTitles();

    // Get comprehensive title groups
    const allTitleGroups = getAllTitleGroups();
    
    // Get comprehensive project groups (now hierarchical by branch -> PM -> project)
    const allProjectGroups = getAllProjectGroups();

    // Force re-render when data changes
    useEffect(() => {

    }, [procoreLaborList, fieldServiceLaborList, completeTechList, availableTitles.length]);

    return (
        <div className='Labor-Equipment-Dashboard'>
            {/* Header */}
            <div className="labor-calendar-header">
                <div className="labor-filter-controls">
                    {viewMode === 'title' ? (
                        <>
                            <div className="labor-filter-group">
                                <div className="labor-filter-dropdown-container">
                                    <button 
                                        className="labor-filter-dropdown-button"
                                onClick={() => {
                                    console.log('Dropdown clicked, current state:', titleDropdownOpen);
                                    console.log('Available titles when clicked:', availableTitles);
                                    setTitleDropdownOpen(!titleDropdownOpen);
                                }}
                            >
                                <span className="dropdown-button-text">
                                    {titleFilter.length === 0 
                                        ? 'All Titles' 
                                        : titleFilter.length === 1 
                                            ? titleFilter[0]
                                            : `${titleFilter.length} Titles Selected`
                                    }
                                </span>
                                <span className={`dropdown-arrow ${titleDropdownOpen ? 'open' : ''}`}>▼</span>
                            </button>
                            {titleDropdownOpen && (
                                <div className="labor-filter-dropdown-menu" style={{ zIndex: 9999 }}>
                                    <div className="dropdown-header">
                                        <span className="dropdown-title">Select Job Titles</span>
                                        {titleFilter.length > 0 && (
                                            <button 
                                                className="clear-all-button"
                                                onClick={clearAllTitleFilters}
                                            >
                                                Clear All
                                            </button>
                                        )}
                                    </div>
                                    <div className="dropdown-options">
                                        {availableTitles && availableTitles.length > 0 ? (
                                            availableTitles.map((title, index) => {
                                                console.log(`Rendering option ${index}:`, title);
                                                return (
                                                    <label key={`${title}-${index}`} className="dropdown-option">
                                                        <input
                                                            type="checkbox"
                                                            checked={titleFilter.includes(title)}
                                                            onChange={() => toggleTitleSelection(title)}
                                                        />
                                                        <span className="checkbox-custom"></span>
                                                        <span className="option-text">{title}</span>
                                                    </label>
                                                );
                                            })
                                        ) : (
                                            <div className="dropdown-option no-options">
                                                <span className="option-text">
                                                    {availableTitles.length === 0 ? 'No job titles available' : 'Loading titles...'}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    {/* Saved Views Dropdown */}
                    <div className="labor-filter-group">
                        <div className="labor-filter-dropdown-container">
                            <button 
                                className="labor-filter-dropdown-button labor-views-dropdown-button"
                                onClick={() => setViewDropdownOpen(!viewDropdownOpen)}
                            >
                                <span className="dropdown-button-text">
                                    {selectedView ? selectedView.name : 'Saved Views'}
                                </span>
                                <span className={`dropdown-arrow ${viewDropdownOpen ? 'open' : ''}`}>▼</span>
                            </button>
                            {viewDropdownOpen && (
                                <div className="labor-filter-dropdown-menu labor-views-menu" style={{ zIndex: 9999 }}>
                                    <div className="dropdown-header">
                                        <span className="dropdown-title">Saved Views</span>
                                        <button 
                                            className="create-view-button"
                                            onClick={openCreateViewModal}
                                        >
                                            + New
                                        </button>
                                    </div>
                                    <div className="dropdown-options">
                                        {savedViews.length > 0 ? (
                                            savedViews.map(view => (
                                                <div key={view.id} className="dropdown-view-option">
                                                    <div 
                                                        className="view-option-main"
                                                        onClick={() => applyView(view)}
                                                    >
                                                        <span className="view-option-name">{view.name}</span>
                                                        <span className="view-option-count">({view.titles.length})</span>
                                                    </div>
                                                    <div className="view-option-actions">
                                                        <button
                                                            className="view-action-button edit"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openEditViewModal(view);
                                                            }}
                                                            title="Edit view"
                                                        >
                                                            ✎
                                                        </button>
                                                        <button
                                                            className="view-action-button delete"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSavedViews([]);
                                                                deleteView(view.id);
                                                            }}
                                                            title="Delete view"
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="dropdown-option no-options">
                                                <span className="option-text">No saved views</span>
                                            </div>
                                        )}
                                    </div>
                                    {selectedView && (
                                        <div className="dropdown-footer">
                                            <button 
                                                className="clear-view-button"
                                                onClick={clearSelectedView}
                                            >
                                                Clear Selection
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div className="labor-filter-group">
                        <input
                            type="text"
                            className="labor-search-input"
                            placeholder="Search employee names..."
                            value={nameSearch}
                            onChange={(e) => setNameSearch(e.target.value)}
                        />
                        {nameSearch && (
                            <button 
                                className="labor-clear-search"
                                onClick={() => setNameSearch('')}
                                title="Clear search"
                            >
                                ×
                            </button>
                        )}
                    </div>
                    
                    {(titleFilter.length > 0 || nameSearch) && (
                        <button 
                            className="labor-clear-all-filters"
                            onClick={() => {
                                setTitleFilter([]);
                                setNameSearch('');
                                setSelectedView(null);
                            }}
                        >
                            Clear All
                        </button>
                    )}
                        </>
                    ) : (
                        <>
                            <div className="labor-filter-group">
                                <div className="labor-filter-dropdown-container">
                                    <button 
                                        className="labor-filter-dropdown-button"
                                        onClick={() => {
                                            setBranchDropdownOpen(!branchDropdownOpen);
                                        }}
                                    >
                                        <span className="dropdown-button-text">
                                            {branchFilter.length === 0 && pmFilter.length === 0
                                                ? 'All Branches & PMs' 
                                                : branchFilter.length + pmFilter.length === 1 
                                                    ? `1 Selection`
                                                    : `${branchFilter.length + pmFilter.length} Selections`
                                            }
                                        </span>
                                        <span className={`dropdown-arrow ${branchDropdownOpen ? 'open' : ''}`}>▼</span>
                                    </button>
                                    {branchDropdownOpen && (
                                        <div className="labor-filter-dropdown-menu" style={{ zIndex: 9999 }}>
                                            <div className="dropdown-header">
                                                <span className="dropdown-title">Select Branches & Project Managers</span>
                                                {(branchFilter.length > 0 || pmFilter.length > 0) && (
                                                    <button 
                                                        className="clear-all-button"
                                                        onClick={clearAllBranchFilters}
                                                    >
                                                        Clear All
                                                    </button>
                                                )}
                                            </div>
                                            <div className="dropdown-options">
                                                {Object.keys(allProjectGroups).length > 0 ? (
                                                    Object.entries(allProjectGroups)
                                                        .sort(([branchA], [branchB]) => branchA.localeCompare(branchB))
                                                        .map(([branchId, branchGroup]) => (
                                                            <div key={branchId} className="dropdown-branch-group">
                                                                {/* Branch Checkbox */}
                                                                <label className="dropdown-option dropdown-branch-option">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={branchFilter.includes(branchId)}
                                                                        onChange={() => toggleBranchSelection(branchId)}
                                                                    />
                                                                    <span className="checkbox-custom"></span>
                                                                    <span className="option-text branch-text">Branch {branchId}</span>
                                                                </label>
                                                                
                                                                {/* Project Managers under this branch */}
                                                                <div className="dropdown-pm-list">
                                                                    {Object.entries(branchGroup.projectManagers)
                                                                        .sort(([pmA], [pmB]) => pmA.localeCompare(pmB))
                                                                        .map(([pmName, pmGroup]) => {
                                                                            const pmKey = `${branchId}|${pmName}`;
                                                                            const projectCount = Object.keys(pmGroup.projects).length;
                                                                            return (
                                                                                <label key={pmKey} className="dropdown-option dropdown-pm-option">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={pmFilter.includes(pmKey)}
                                                                                        onChange={() => togglePMSelection(branchId, pmName)}
                                                                                    />
                                                                                    <span className="checkbox-custom"></span>
                                                                                    <span className="option-text pm-text">
                                                                                        {pmName} <span className="pm-project-count">({projectCount})</span>
                                                                                    </span>
                                                                                </label>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div className="dropdown-option no-options">
                                                        <span className="option-text">No branches available</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className="labor-filter-group">
                                <input
                                    type="text"
                                    className="labor-search-input"
                                    placeholder="Search project number or name..."
                                    value={projectSearch}
                                    onChange={(e) => setProjectSearch(e.target.value)}
                                />
                                {projectSearch && (
                                    <button 
                                        className="labor-clear-search"
                                        onClick={() => setProjectSearch('')}
                                        title="Clear search"
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                            
                            {(branchFilter.length > 0 || pmFilter.length > 0 || projectSearch) && (
                                <button 
                                    className="labor-clear-all-filters"
                                    onClick={() => {
                                        setBranchFilter([]);
                                        setPmFilter([]);
                                        setProjectSearch('');
                                        setSelectedView(null);
                                    }}
                                >
                                    Clear All
                                </button>
                            )}
                        </>
                    )}
                    
                    <div className="labor-results-summary">
                        {filteredEmployees.length + filteredSubcontractors.length + filteredTechnicians.length} of {(employees?.length || 0) + (subcontractors?.length || 0) + (technicians?.length || 0)} people
                    </div>
                    
                    <div className="labor-view-toggle-container">
                        <div className="labor-view-toggle">
                            <button 
                                className={`labor-view-toggle-button ${viewMode === 'title' ? 'active' : ''}`}
                                onClick={() => setViewMode('title')}
                            >
                                Title
                            </button>
                            <button 
                                className={`labor-view-toggle-button ${viewMode === 'project' ? 'active' : ''}`}
                                onClick={() => setViewMode('project')}
                            >
                                Project
                            </button>
                        </div>
                    </div>
                    
                    <div className="labor-view-toggle-container">
                        <div className="labor-view-toggle">
                            <button 
                                className={`labor-view-toggle-button ${periodMode === 'week' ? 'active' : ''}`}
                                onClick={() => setPeriodMode('week')}
                            >
                                Week
                            </button>
                            <button 
                                className={`labor-view-toggle-button ${periodMode === 'month' ? 'active' : ''}`}
                                onClick={() => setPeriodMode('month')}
                            >
                                Month
                            </button>
                        </div>
                    </div>
                </div>
                
                <div className="labor-header-navigation">
                    <div className='labor-navigation-container'>
                        {/*<div className="labor-period">{getCurrentWeekString()}</div>*/}
                        <div className="labor-navigation">
                            <button className="labor-nav-button" onClick={navigatePrevious}>
                                ‹
                            </button>
                            <button className="labor-today-button" onClick={navigateToday}>
                                Today
                            </button>
                            <button className="labor-nav-button" onClick={navigateNext}>
                                ›
                            </button>
                        </div> 
                    </div>

                    
                    <div className="labor-quick-selector">
                        <select 
                            className="labor-quick-select"
                            value={getQuickSelectorOptions().find(opt => {
                                const optDate = new Date(opt.value);
                                const currentWeekStart = new Date(currentDate);
                                currentWeekStart.setDate(currentDate.getDate() - currentDate.getDay());
                                
                                const monthStart = new Date(optDate.getFullYear(), optDate.getMonth(), 1);
                                const monthEnd = new Date(optDate.getFullYear(), optDate.getMonth() + 1, 0);
                                
                                return currentWeekStart >= new Date(monthStart.getFullYear(), monthStart.getMonth(), 1 - monthStart.getDay()) &&
                                       currentWeekStart <= monthEnd;
                            })?.value || getQuickSelectorOptions()[0]?.value}
                            onChange={(e) => jumpToDate(e.target.value)}
                        >
                            {getQuickSelectorOptions().map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {/* Calendar Grid */}
            <div className="labor-calendar-grid">
                {/* Month Headers */}
                <div className="labor-month-header">
                    <div className="labor-employee-column-spacer"></div>
                    {getMonthHeaders().map((monthInfo, index) => (
                        <div 
                            key={index} 
                            className="labor-month-cell"
                            style={{ gridColumn: `span ${monthInfo.span}` }}
                        >
                            {monthInfo.month}
                        </div>
                    ))}
                </div>

                {/* Week/Month Headers */}
                <div className="labor-dates-header">
                    <div className="labor-employee-column-header">
                        {viewMode === 'title' ? 'Employees' : 'Projects'}
                    </div>
                    {periodDates.map((periodStart, index) => {
                        if (periodMode === 'month') {
                            // Month mode
                            const monthEnd = new Date(periodStart.getFullYear(), periodStart.getMonth() + 1, 0);
                            const isCurrentMonth = () => {
                                const today = new Date();
                                return today.getFullYear() === periodStart.getFullYear() && 
                                       today.getMonth() === periodStart.getMonth();
                            };
                            
                            return (
                                <div key={index} className={`labor-date-header ${isCurrentMonth() ? 'current-week' : ''}`}>
                                    <div className="week-start-date">
                                        {periodStart.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
                                    </div>
                                </div>
                            );
                        } else {
                            // Week mode
                            const weekEnd = new Date(periodStart);
                            weekEnd.setDate(weekEnd.getDate() + 6);
                            const isCurrentWeek = () => {
                                const today = new Date();
                                return today >= periodStart && today <= weekEnd;
                            };
                            
                            // Check if this is the start of a new month
                            const isMonthStart = index > 0 && 
                                periodStart.getMonth() !== periodDates[index - 1].getMonth();
                            
                            return (
                                <div key={index} className={`labor-date-header ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}>
                                    <div className="week-start-date">{formatDate(periodStart)}</div>
                                </div>
                            );
                        }
                    })}
                </div>

                {/* Employee/Project Rows - Conditionally render based on view mode */}
                <div className="labor-employee-rows">
                    {viewMode === 'title' ? (
                        <>
                            {/* Render non-service tech title groups first */}
                            {Object.entries(allTitleGroups)
                                .filter(([title, titleGroup]) => !titleGroup.isServiceTech)
                                .filter(([title, titleGroup]) => {
                                    // Show title groups in these cases:
                                    // 1. They have employees after filtering
                                    // 2. No filters are applied (show all titles)
                                    // 3. Title filter is applied and this title matches (even if no employees)
                                    const hasMatchingEmployees = titleGroup.totalCount > 0;
                                    const noFiltersApplied = titleFilter.length === 0 && nameSearch === '';
                                    const titleMatches = titleFilter.length > 0 && titleFilter.some(selectedTitle => 
                                        title.toLowerCase().includes(selectedTitle.toLowerCase())
                                    );
                                    
                                    return hasMatchingEmployees || noFiltersApplied || titleMatches;
                                })
                                .sort(([titleA], [titleB]) => titleA.localeCompare(titleB))
                                .map(([title, titleGroup]) => (
                            <div key={title} className="labor-title-group">
                                <div 
                                    className="labor-title-header"
                                >
                                    <div 
                                        className="labor-title-name"
                                        style={{
                                            borderLeft: titleGroup.color ? `4px solid ${titleGroup.color}` : 'none'
                                        }}
                                    >
                                        {title} <span className="labor-title-count">({titleGroup.totalCount})</span>
                                        {titleGroup.color && (
                                            <div 
                                                className="labor-title-color-indicator"
                                                style={{ backgroundColor: titleGroup.color }}
                                                title={`Title Color: ${titleGroup.color}`}
                                            />
                                        )}
                                    </div>
                                    {periodDates.map((periodStart, dateIndex) => {
                                        if (periodMode === 'month') {
                                            // Month mode
                                            const monthEnd = new Date(periodStart.getFullYear(), periodStart.getMonth() + 1, 0);
                                            const isCurrentMonth = () => {
                                                const today = new Date();
                                                return today.getFullYear() === periodStart.getFullYear() && 
                                                       today.getMonth() === periodStart.getMonth();
                                            };
                                            
                                            // Find the week with the highest request count for this title in this month
                                            let maxRequestCount = 0;
                                            let maxWeekKey = null;
                                            let maxWeekDate = null;
                                            
                                            if (weeklyRequests) {
                                                Object.keys(weeklyRequests).forEach(weekKey => {
                                                    const [month, day, year] = weekKey.split('/').map(Number);
                                                    const weekDate = new Date(year, month - 1, day);
                                                    
                                                    // Check if this week falls within the month
                                                    if (weekDate >= periodStart && weekDate <= monthEnd) {
                                                        const requestCount = weeklyRequests[weekKey]?.[title] || 0;
                                                        if (requestCount > maxRequestCount) {
                                                            maxRequestCount = requestCount;
                                                            maxWeekKey = weekKey;
                                                            maxWeekDate = weekDate;
                                                        }
                                                    }
                                                });
                                            }
                                            
                                            // Calculate availability for the week with max requests
                                            let showWarning = false;
                                            if (maxWeekDate && maxRequestCount > 0) {
                                                // Count available employees for that specific week
                                                const availableCount = titleGroup.employees.filter(employee => {
                                                    const projects = getProjectsForWeek(employee, maxWeekDate);
                                                    return projects.length === 0;
                                                }).length;
                                                
                                                showWarning = maxRequestCount > availableCount;
                                            }
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-title-divider ${isCurrentMonth() ? 'current-week' : ''}`}
                                                >
                                                    {maxRequestCount > 0 && (
                                                        <span 
                                                            className={`labor-title-request-count ${showWarning ? 'warning' : ''}`}
                                                            title={showWarning ? `Warning: ${maxRequestCount} requests (week of ${maxWeekDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}). Click for details.` : `${maxRequestCount} request${maxRequestCount !== 1 ? 's' : ''} (week of ${maxWeekDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}). Click for details.`}
                                                            onClick={() => maxWeekKey && handleRequestClick(title, maxWeekKey)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {maxRequestCount}
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        } else {
                                            // Week mode
                                            const weekEnd = new Date(periodStart);
                                            weekEnd.setDate(weekEnd.getDate() + 6);
                                            const isCurrentWeek = () => {
                                                const today = new Date();
                                                return today >= periodStart && today <= weekEnd;
                                            };
                                            
                                            const isMonthStart = dateIndex > 0 && 
                                                periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                            
                                            // Format the date to match weeklyRequests key format (M/D/YYYY)
                                            const weekKey = `${periodStart.getMonth() + 1}/${periodStart.getDate()}/${periodStart.getFullYear()}`;
                                            
                                            // Get the request count for this title and week
                                            const requestCount = weeklyRequests?.[weekKey]?.[title] || 0;
                                            
                                            // Count available employees (those with no projects this week)
                                            const availableCount = titleGroup.employees.filter(employee => {
                                                const projects = getProjectsForWeek(employee, periodStart);
                                                return projects.length === 0;
                                            }).length;
                                            
                                            // Determine if we need to show warning (requests exceed available employees)
                                            const showWarning = requestCount > availableCount;
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-title-divider ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                >
                                                    {requestCount > 0 && (
                                                        <span 
                                                            className={`labor-title-request-count ${showWarning ? 'warning' : ''}`}
                                                            title={showWarning ? `Warning: ${requestCount} requests but only ${availableCount} available. Click for details.` : `${availableCount} available. Click for details.`}
                                                            onClick={() => handleRequestClick(title, weekKey)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {requestCount}
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                                
                                {/* Render employees for this title */}
                                {titleGroup.employees.map((employee, index) => (
                                    <div key={employee.employeeId || `labor-${title}-${index}`} className="labor-employee-row">
                                        <div className="labor-employee-info">
                                            <div className="labor-employee-id">
                                                {employee.employeeId || 'N/A'}
                                            </div>
                                            <div className="labor-employee-name">
                                                {employee.name}
                                            </div>
                                            <div className="labor-employee-title">
                                                {employee.title}
                                            </div>
                                        </div>
                                        
                                        {periodDates.map((periodStart, dateIndex) => {
                                            const projects = periodMode === 'month' ? 
                                                getProjectsForMonth(employee, periodStart) : 
                                                getProjectsForWeek(employee, periodStart);
                                            
                                            if (periodMode === 'month') {
                                                // Month mode
                                                const monthEnd = new Date(periodStart.getFullYear(), periodStart.getMonth() + 1, 0);
                                                const isCurrentMonth = () => {
                                                    const today = new Date();
                                                    return today.getFullYear() === periodStart.getFullYear() && 
                                                           today.getMonth() === periodStart.getMonth();
                                                };
                                                
                                                return (
                                                    <div 
                                                        key={dateIndex} 
                                                        className={`labor-week-cell ${isCurrentMonth() ? 'current-week' : ''}`}
                                                    >
                                                        <div className="labor-week-content">
                                                            {projects.map((project, projectIndex) => (
                                                                <div 
                                                                    key={projectIndex} 
                                                                    className="labor-project appointment-tile"
                                                                    style={{ 
                                                                        backgroundColor: `${titleGroup.color || employee.color || 'var(--primary-color, #065943)'}40`,
                                                                        border: `3px solid ${titleGroup.color || employee.color || 'var(--primary-color, #065943)'}`,
                                                                        '--project-color': titleGroup.color || employee.color || 'var(--primary-color, #065943)'
                                                                    }}
                                                                    title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                                >
                                                                    <div className="labor-project-number">
                                                                        {project.projectNumber}
                                                                    </div>
                                                                    <div className="labor-project-name">
                                                                        {project.projectName}
                                                                    </div>
                                                                    {project.percentAllocated && (
                                                                        <div className="labor-project-allocation">
                                                                            {project.percentAllocated}%
                                                                        </div>
                                                                    )}
                                                                    {project.customerName && (
                                                                        <div className="labor-project-customer">
                                                                            {project.customerName}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                // Week mode
                                                const weekEnd = new Date(periodStart);
                                                weekEnd.setDate(weekEnd.getDate() + 6);
                                                const isCurrentWeek = () => {
                                                    const today = new Date();
                                                    return today >= periodStart && today <= weekEnd;
                                                };
                                                
                                                const isMonthStart = dateIndex > 0 && 
                                                    periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                                
                                                return (
                                                    <div 
                                                        key={dateIndex} 
                                                        className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                    >
                                                        <div className="labor-week-content">
                                                            {projects.map((project, projectIndex) => (
                                                                <div 
                                                                    key={projectIndex} 
                                                                    className="labor-project appointment-tile"
                                                                    style={{ 
                                                                        backgroundColor: `${titleGroup.color || employee.color || 'var(--primary-color, #065943)'}40`,
                                                                        border: `3px solid ${titleGroup.color || employee.color || 'var(--primary-color, #065943)'}`,
                                                                        '--project-color': titleGroup.color || employee.color || 'var(--primary-color, #065943)'
                                                                    }}
                                                                    title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                                >
                                                                    <div className="labor-project-number">
                                                                        {project.projectNumber}
                                                                    </div>
                                                                    <div className="labor-project-name">
                                                                        {project.projectName}
                                                                    </div>
                                                                    {project.percentAllocated && (
                                                                        <div className="labor-project-allocation">
                                                                            {project.percentAllocated}%
                                                                        </div>
                                                                    )}
                                                                    {project.customerName && (
                                                                        <div className="labor-project-customer">
                                                                            {project.customerName}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                ))}

                                {/* Render subcontractors for this title */}
                                {titleGroup.subcontractors.map((subcontractor, index) => (
                                    <div key={`subcontractor-${title}-${index}`} className="labor-employee-row">
                                        <div className="labor-employee-info">
                                            <div className="labor-employee-id">
                                                SUB
                                            </div>
                                            <div className="labor-employee-name">
                                                {subcontractor.name}
                                            </div>
                                            <div className="labor-employee-title">
                                                {subcontractor.title}
                                            </div>
                                        </div>
                                        
                                        {periodDates.map((periodStart, dateIndex) => {
                                            const projects = periodMode === 'month' ? 
                                                getProjectsForMonth(subcontractor, periodStart) : 
                                                getProjectsForWeek(subcontractor, periodStart);
                                            const weekEnd = new Date(periodStart);
                                            weekEnd.setDate(weekEnd.getDate() + 6);
                                            const isCurrentWeek = () => {
                                                const today = new Date();
                                                return today >= periodStart && today <= weekEnd;
                                            };
                                            
                                            const isMonthStart = dateIndex > 0 && 
                                                periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                >
                                                    <div className="labor-week-content">
                                                        {projects.map((project, projectIndex) => (
                                                            <div 
                                                                key={projectIndex} 
                                                                className="labor-project labor-subcontractor appointment-tile"
                                                                style={{ 
                                                                    backgroundColor: `${titleGroup.color || subcontractor.color || 'var(--secondary-color, #ff9800)'}40`,
                                                                    border: `3px solid ${titleGroup.color || subcontractor.color || 'var(--secondary-color, #ff9800)'}`,
                                                                    '--project-color': titleGroup.color || subcontractor.color || 'var(--secondary-color, #ff9800)'
                                                                }}
                                                                title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                            >
                                                                <div className="labor-project-number">
                                                                    {project.projectNumber}
                                                                </div>
                                                                <div className="labor-project-name">
                                                                    {project.projectName}
                                                                </div>
                                                                {project.percentAllocated && (
                                                                    <div className="labor-project-allocation">
                                                                        {project.percentAllocated}%
                                                                    </div>
                                                                )}
                                                                {project.customerName && (
                                                                    <div className="labor-project-customer">
                                                                        {project.customerName}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}

                                {/* Render technicians for this title */}
                                {titleGroup.technicians.map((technician, index) => (
                                    <div key={`technician-${title}-${index}`} className="labor-employee-row">
                                        <div className="labor-employee-info">
                                            <div className="labor-employee-id">
                                                {technician.employeeId}
                                            </div>
                                            <div className="labor-employee-name">
                                                {technician.name}
                                            </div>
                                            <div className="labor-employee-title">
                                                {technician.title}
                                            </div>
                                        </div>
                                        
                                        {weekDates.map((weekStart, dateIndex) => {
                                            const projects = getProjectsForWeek(technician, weekStart);
                                            const weekEnd = new Date(weekStart);
                                            weekEnd.setDate(weekEnd.getDate() + 6);
                                            const isCurrentWeek = () => {
                                                const today = new Date();
                                                return today >= weekStart && today <= weekEnd;
                                            };
                                            
                                            const isMonthStart = dateIndex > 0 && 
                                                weekStart.getMonth() !== weekDates[dateIndex - 1].getMonth();
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                >
                                                    <div className="labor-week-content">
                                                        {projects.map((project, projectIndex) => (
                                                            <div 
                                                                key={projectIndex} 
                                                                className="labor-project labor-technician appointment-tile service-appointment"
                                                                style={{ 
                                                                    backgroundColor: `rgba(${titleGroup.color || technician.color || 'var(--primary-color, #065943)'}, 0.4)`,
                                                                    border: `3px solid ${titleGroup.color || technician.color || 'var(--primary-color, #065943)'}`,
                                                                    '--project-color': titleGroup.color || technician.color || 'var(--primary-color, #065943)'
                                                                }}
                                                                title={`${project.appointmentNbr || project.projectNumber} - ${project.workScopeText || project.projectName}\nCustomer: ${project.customerName || 'N/A'}\nLocation: ${project.location || 'N/A'}`}
                                                            >
                                                                <div className="labor-project-number">
                                                                    {project.appointmentNbr || project.projectNumber}
                                                                </div>
                                                                <div className="labor-project-name">
                                                                    {project.workScopeText || project.projectName}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        ))
                    }
                    
                    {/* Render service tech title groups at the bottom */}
                    {Object.entries(allTitleGroups)
                        .filter(([title, titleGroup]) => titleGroup.isServiceTech)
                        .filter(([title, titleGroup]) => {
                            // Show title groups in these cases:
                            // 1. They have employees after filtering
                            // 2. No filters are applied (show all titles)
                            // 3. Title filter is applied and this title matches (even if no employees)
                            const hasMatchingEmployees = titleGroup.totalCount > 0;
                            const noFiltersApplied = titleFilter.length === 0 && nameSearch === '';
                            const titleMatches = titleFilter.length > 0 && titleFilter.some(selectedTitle => 
                                title.toLowerCase().includes(selectedTitle.toLowerCase())
                            );
                            
                            return hasMatchingEmployees || noFiltersApplied || titleMatches;
                        })
                        .sort(([titleA], [titleB]) => titleA.localeCompare(titleB))
                        .map(([title, titleGroup]) => (
                            <div key={title} className="labor-title-group">
                                <div 
                                    className="labor-title-header"

                                >
                                    <div 
                                        className="labor-title-name"
                                        style={{
                                            borderLeft: titleGroup.color ? `4px solid ${titleGroup.color}` : 'none'
                                        }}
                                    >
                                        {title} <span className="labor-title-count">({titleGroup.totalCount})</span>
                                        {titleGroup.color && (
                                            <div 
                                                className="labor-title-color-indicator"
                                                style={{ backgroundColor: titleGroup.color }}
                                                title={`Title Color: ${titleGroup.color}`}
                                            />
                                        )}
                                    </div>
                                    {weekDates.map((weekStart, dateIndex) => {
                                        const weekEnd = new Date(weekStart);
                                        weekEnd.setDate(weekEnd.getDate() + 6);
                                        const isCurrentWeek = () => {
                                            const today = new Date();
                                            return today >= weekStart && today <= weekEnd;
                                        };
                                        
                                        const isMonthStart = dateIndex > 0 && 
                                            weekStart.getMonth() !== weekDates[dateIndex - 1].getMonth();
                                        
                                        // Format the date to match weeklyRequests key format (M/D/YYYY)
                                        const weekKey = `${weekStart.getMonth() + 1}/${weekStart.getDate()}/${weekStart.getFullYear()}`;
                                        
                                        // Get the request count for this title and week
                                        const requestCount = weeklyRequests?.[weekKey]?.[title] || 0;
                                        
                                        // Count available employees (those with no projects this week)
                                        const availableCount = titleGroup.employees.filter(employee => {
                                            const projects = getProjectsForWeek(employee, weekStart);
                                            return projects.length === 0;
                                        }).length;
                                        
                                        // Determine if we need to show warning (requests exceed available employees)
                                        const showWarning = requestCount > availableCount;
                                        
                                        return (
                                            <div 
                                                key={dateIndex} 
                                                className={`labor-title-divider ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                            >
                                                {requestCount > 0 && (
                                                    <span 
                                                        className={`labor-title-request-count ${showWarning ? 'warning' : ''}`}
                                                        title={showWarning ? `Warning: ${requestCount} requests but only ${availableCount} available. Click for details.` : `${availableCount} available. Click for details.`}
                                                        onClick={() => handleRequestClick(title, weekKey)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {requestCount}
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                
                                {/* Render employees for this title */}
                                {titleGroup.employees.map((employee, index) => (
                                    <div key={employee.employeeId || `labor-${title}-${index}`} className="labor-employee-row">
                                        <div className="labor-employee-info">
                                            <div className="labor-employee-id">
                                                {employee.employeeId || 'N/A'}
                                            </div>
                                            <div className="labor-employee-name">
                                                {employee.name}
                                            </div>
                                            <div className="labor-employee-title">
                                                {employee.title}
                                            </div>
                                        </div>
                                        
                                        {weekDates.map((weekStart, dateIndex) => {
                                            const projects = getProjectsForWeek(employee, weekStart);
                                            const weekEnd = new Date(weekStart);
                                            weekEnd.setDate(weekEnd.getDate() + 6);
                                            const isCurrentWeek = () => {
                                                const today = new Date();
                                                return today >= weekStart && today <= weekEnd;
                                            };
                                            
                                            const isMonthStart = dateIndex > 0 && 
                                                weekStart.getMonth() !== weekDates[dateIndex - 1].getMonth();
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                >
                                                    <div className="labor-week-content">
                                                        {projects.map((project, projectIndex) => (
                                                            <div 
                                                                key={projectIndex} 
                                                                className="labor-project appointment-tile"
                                                                style={{ 
                                                                    backgroundColor: titleGroup.color || employee.color || 'var(--primary-color, #065943)',
                                                                    '--project-color': titleGroup.color || employee.color || 'var(--primary-color, #065943)'
                                                                }}
                                                                title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                            >
                                                                <div className="labor-project-number">
                                                                    {project.projectNumber}
                                                                </div>
                                                                <div className="labor-project-name">
                                                                    {project.projectName}
                                                                </div>
                                                                {project.percentAllocated && (
                                                                    <div className="labor-project-allocation">
                                                                        {project.percentAllocated}%
                                                                    </div>
                                                                )}
                                                                {project.customerName && (
                                                                    <div className="labor-project-customer">
                                                                        {project.customerName}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}

                                {/* Render subcontractors for this title */}
                                {titleGroup.subcontractors.map((subcontractor, index) => (
                                    <div key={`subcontractor-${title}-${index}`} className="labor-employee-row">
                                        <div className="labor-employee-info">
                                            <div className="labor-employee-id">
                                                SUB
                                            </div>
                                            <div className="labor-employee-name">
                                                {subcontractor.name}
                                            </div>
                                            <div className="labor-employee-title">
                                                {subcontractor.title}
                                            </div>
                                        </div>
                                        
                                        {weekDates.map((weekStart, dateIndex) => {
                                            const projects = getProjectsForWeek(subcontractor, weekStart);
                                            const weekEnd = new Date(weekStart);
                                            weekEnd.setDate(weekEnd.getDate() + 6);
                                            const isCurrentWeek = () => {
                                                const today = new Date();
                                                return today >= weekStart && today <= weekEnd;
                                            };
                                            
                                            const isMonthStart = dateIndex > 0 && 
                                                weekStart.getMonth() !== weekDates[dateIndex - 1].getMonth();
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                >
                                                    <div className="labor-week-content">
                                                        {projects.map((project, projectIndex) => (
                                                            <div 
                                                                key={projectIndex} 
                                                                className="labor-project labor-subcontractor appointment-tile"
                                                                style={{ 
                                                                    backgroundColor: titleGroup.color || subcontractor.color || 'var(--secondary-color, #ff9800)',
                                                                    '--project-color': titleGroup.color || subcontractor.color || 'var(--secondary-color, #ff9800)'
                                                                }}
                                                                title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                            >
                                                                <div className="labor-project-number">
                                                                    {project.projectNumber}
                                                                </div>
                                                                <div className="labor-project-name">
                                                                    {project.projectName}
                                                                </div>
                                                                {project.percentAllocated && (
                                                                    <div className="labor-project-allocation">
                                                                        {project.percentAllocated}%
                                                                    </div>
                                                                )}
                                                                {project.customerName && (
                                                                    <div className="labor-project-customer">
                                                                        {project.customerName}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}

                                {/* Render technicians for this title */}
                                {titleGroup.technicians.map((technician, index) => (
                                    <div key={`technician-${title}-${index}`} className="labor-employee-row">
                                        <div className="labor-employee-info">
                                            <div className="labor-employee-id">
                                                {technician.employeeId}
                                            </div>
                                            <div className="labor-employee-name">
                                                {technician.name}
                                            </div>
                                            <div className="labor-employee-title">
                                                {technician.title}
                                            </div>
                                        </div>
                                        
                                        {weekDates.map((weekStart, dateIndex) => {
                                            const projects = getProjectsForWeek(technician, weekStart);
                                            const weekEnd = new Date(weekStart);
                                            weekEnd.setDate(weekEnd.getDate() + 6);
                                            const isCurrentWeek = () => {
                                                const today = new Date();
                                                return today >= weekStart && today <= weekEnd;
                                            };
                                            
                                            const isMonthStart = dateIndex > 0 && 
                                                weekStart.getMonth() !== weekDates[dateIndex - 1].getMonth();
                                            
                                            return (
                                                <div 
                                                    key={dateIndex} 
                                                    className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                >
                                                    <div className="labor-week-content">
                                                        {projects.map((project, projectIndex) => (
                                                            <div 
                                                                key={projectIndex} 
                                                                className="labor-project labor-technician appointment-tile service-appointment"
                                                                style={{ 
                                                                    backgroundColor: `rgba(6, 89, 79, 0.3)`,
                                                                    border: `3px solid var(--primary-color, #065943)`,
                                                                    '--project-color': 'var(--primary-color, #065943)'
                                                                }}
                                                                title={`${project.appointmentNbr || project.projectNumber} - ${project.workScopeText || project.projectName}\nCustomer: ${project.customerName || 'N/A'}\nLocation: ${project.location || 'N/A'}`}
                                                            >
                                                                <div className="labor-project-number">
                                                                    {project.appointmentNbr || project.projectNumber}
                                                                </div>
                                                                <div className="labor-project-name">
                                                                    {project.workScopeText || project.projectName}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        ))
                    }
                        </>
                    ) : (
                        <>
                            {/* Render project groups when in project view - hierarchical by branch -> PM -> project -> title */}
                            {Object.entries(allProjectGroups)
                                .filter(([branchId, branchGroup]) => {
                                    // If branch filters are active, only show selected branches
                                    if (branchFilter.length > 0 && !branchFilter.includes(branchId)) {
                                        return false;
                                    }
                                    // If PM filters are active, check if any PM in this branch is selected
                                    if (pmFilter.length > 0) {
                                        const hasPMMatch = Object.keys(branchGroup.projectManagers).some(pmName => {
                                            const pmKey = `${branchId}|${pmName}`;
                                            return pmFilter.includes(pmKey);
                                        });
                                        if (!hasPMMatch) {
                                            return false;
                                        }
                                    }
                                    return true;
                                })
                                .sort(([branchA], [branchB]) => branchA.localeCompare(branchB))
                                .map(([branchId, branchGroup]) => (
                                    <React.Fragment key={branchId}>
                                        {/* Branch Header */}
                                        <div className="labor-branch-header">
                                            <div className="labor-branch-name">
                                                Branch {branchId}
                                            </div>
                                            {periodDates.map((periodStart, dateIndex) => {
                                                if (periodMode === 'month') {
                                                    const isCurrentMonth = () => {
                                                        const today = new Date();
                                                        return today.getFullYear() === periodStart.getFullYear() && 
                                                               today.getMonth() === periodStart.getMonth();
                                                    };
                                                    return (
                                                        <div 
                                                            key={dateIndex} 
                                                            className={`labor-title-divider ${isCurrentMonth() ? 'current-week' : ''}`}
                                                        />
                                                    );
                                                } else {
                                                    const weekEnd = new Date(periodStart);
                                                    weekEnd.setDate(weekEnd.getDate() + 6);
                                                    const isCurrentWeek = () => {
                                                        const today = new Date();
                                                        return today >= periodStart && today <= weekEnd;
                                                    };
                                                    
                                                    const isMonthStart = dateIndex > 0 && 
                                                        periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                                    
                                                    return (
                                                        <div 
                                                            key={dateIndex} 
                                                            className={`labor-title-divider ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                        />
                                                    );
                                                }
                                            })}
                                        </div>

                                        {/* Project Managers within this branch */}
                                        {Object.entries(branchGroup.projectManagers)
                                            .filter(([pmName, pmGroup]) => {
                                                // If PM filters are active, only show selected PMs
                                                if (pmFilter.length > 0) {
                                                    const pmKey = `${branchId}|${pmName}`;
                                                    return pmFilter.includes(pmKey);
                                                }
                                                return true;
                                            })
                                            .sort(([pmA], [pmB]) => pmA.localeCompare(pmB))
                                            .map(([pmName, pmGroup]) => (
                                                <React.Fragment key={`${branchId}-${pmName}`}>
                                                    {/* Project Manager Header */}
                                                    <div className="labor-pm-header">
                                                        <div className="labor-pm-name">
                                                            PM: {pmName}
                                                        </div>
                                                        {periodDates.map((periodStart, dateIndex) => {
                                                            if (periodMode === 'month') {
                                                                const isCurrentMonth = () => {
                                                                    const today = new Date();
                                                                    return today.getFullYear() === periodStart.getFullYear() && 
                                                                           today.getMonth() === periodStart.getMonth();
                                                                };
                                                                return (
                                                                    <div 
                                                                        key={dateIndex} 
                                                                        className={`labor-title-divider ${isCurrentMonth() ? 'current-week' : ''}`}
                                                                    />
                                                                );
                                                            } else {
                                                                const weekEnd = new Date(periodStart);
                                                                weekEnd.setDate(weekEnd.getDate() + 6);
                                                                const isCurrentWeek = () => {
                                                                    const today = new Date();
                                                                    return today >= periodStart && today <= weekEnd;
                                                                };
                                                                
                                                                const isMonthStart = dateIndex > 0 && 
                                                                    periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                                                
                                                                return (
                                                                    <div 
                                                                        key={dateIndex} 
                                                                        className={`labor-title-divider ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                                    />
                                                                );
                                                            }
                                                        })}
                                                    </div>

                                                    {/* Projects for this PM */}
                                                    {Object.entries(pmGroup.projects)
                                                        .filter(([projectNumber, projectGroup]) => {
                                                            // Apply project search
                                                            const searchMatch = !projectSearch || 
                                                                projectNumber.toLowerCase().includes(projectSearch.toLowerCase()) ||
                                                                projectGroup.name.toLowerCase().includes(projectSearch.toLowerCase());
                                                            
                                                            return searchMatch;
                                                        })
                                                        .sort(([numA, projA], [numB, projB]) => projA.name.localeCompare(projB.name))
                                                        .map(([projectNumber, projectGroup]) => (
                                                            <div key={projectNumber} className="labor-title-group labor-project-group">
                                                                <div 
                                                                    className="labor-title-header"
                                                                >
                                                                    <div 
                                                                        className="labor-title-name"
                                                                        style={{
                                                                            borderLeft: projectGroup.color ? `4px solid ${projectGroup.color}` : 'none'
                                                                        }}
                                                                    >
                                                                        {projectGroup.number} - {projectGroup.name} <span className="labor-title-count">({projectGroup.totalCount})</span>
                                                                        {projectGroup.color && (
                                                                            <div 
                                                                                className="labor-title-color-indicator"
                                                                                style={{ backgroundColor: projectGroup.color }}
                                                                                title={`Project Color: ${projectGroup.color}`}
                                                                            />
                                                                        )}
                                                                    </div>
                                            {periodDates.map((periodStart, dateIndex) => {
                                                if (periodMode === 'month') {
                                                    const isCurrentMonth = () => {
                                                        const today = new Date();
                                                        return today.getFullYear() === periodStart.getFullYear() && 
                                                               today.getMonth() === periodStart.getMonth();
                                                    };
                                                    return (
                                                        <div 
                                                            key={dateIndex} 
                                                            className={`labor-title-divider ${isCurrentMonth() ? 'current-week' : ''}`}
                                                        >
                                                        </div>
                                                    );
                                                } else {
                                                    const weekEnd = new Date(periodStart);
                                                    weekEnd.setDate(weekEnd.getDate() + 6);
                                                    const isCurrentWeek = () => {
                                                        const today = new Date();
                                                        return today >= periodStart && today <= weekEnd;
                                                    };
                                                    
                                                    const isMonthStart = dateIndex > 0 && 
                                                        periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                                    
                                                    return (
                                                        <div 
                                                            key={dateIndex} 
                                                            className={`labor-title-divider ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                        >
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                        
                                        {/* Group employees by title within this project */}
                                        {(() => {
                                            // Group employees by title
                                            const titleGroups = {};
                                            projectGroup.employees.forEach(employee => {
                                                const title = employee.title || 'Unassigned';
                                                if (!titleGroups[title]) {
                                                    titleGroups[title] = [];
                                                }
                                                titleGroups[title].push(employee);
                                            });
                                            
                                            // Also add titles from projectRequests that may not have employees yet
                                            if (projectRequests?.[projectNumber]) {
                                                Object.keys(projectRequests[projectNumber]).forEach(dateKey => {
                                                    const titlesForDate = projectRequests[projectNumber][dateKey];
                                                    if (titlesForDate && typeof titlesForDate === 'object') {
                                                        Object.keys(titlesForDate).forEach(title => {
                                                            if (!titleGroups[title]) {
                                                                titleGroups[title] = [];
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                            
                                            // Render each title subgroup
                                            return Object.entries(titleGroups)
                                                .sort(([titleA], [titleB]) => titleA.localeCompare(titleB))
                                                .map(([title, employees]) => (
                                                    <>
                                                        {/* Title subheader */}
                                                        <div className="labor-title-subheader">
                                                            <div className="labor-title-name labor-subtitle-name">
                                                                {title} <span className="labor-title-count">({employees.length})</span>
                                                            </div>
                                                            {periodDates.map((periodStart, dateIndex) => {
                                                                if (periodMode === 'month') {
                                                                    // Month mode
                                                                    const monthEnd = new Date(periodStart.getFullYear(), periodStart.getMonth() + 1, 0);
                                                                    const isCurrentMonth = () => {
                                                                        const today = new Date();
                                                                        return today.getFullYear() === periodStart.getFullYear() && 
                                                                               today.getMonth() === periodStart.getMonth();
                                                                    };
                                                                    
                                                                    // Find the week with the highest request count for this title in this project for this month
                                                                    let maxRequestCount = 0;
                                                                    let maxWeekKey = null;
                                                                    let maxWeekDate = null;
                                                                    
                                                                    if (projectRequests?.[projectNumber]) {
                                                                        Object.keys(projectRequests[projectNumber]).forEach(dateKey => {
                                                                            const [month, day, year] = dateKey.split('/').map(Number);
                                                                            const weekDate = new Date(year, month - 1, day);
                                                                            
                                                                            // Check if this week falls within the month
                                                                            if (weekDate >= periodStart && weekDate <= monthEnd) {
                                                                                const requestCount = projectRequests[projectNumber][dateKey]?.[title] || 0;
                                                                                if (requestCount > maxRequestCount) {
                                                                                    maxRequestCount = requestCount;
                                                                                    maxWeekKey = dateKey;
                                                                                    maxWeekDate = weekDate;
                                                                                }
                                                                            }
                                                                        });
                                                                    }
                                                                    
                                                                    // Calculate availability for the week with max requests
                                                                    let showWarning = false;
                                                                    if (maxWeekDate && maxRequestCount > 0) {
                                                                        // Get ALL employees with this title (not just those in this project)
                                                                        const allEmployeesWithTitle = [
                                                                            ...(procoreLaborList?.labor || []),
                                                                            ...(procoreLaborList?.subcontractor || []),
                                                                            ...(technicians || [])
                                                                        ].filter(emp => emp.title === title);
                                                                        
                                                                        // Count available for that specific week
                                                                        const availableCount = allEmployeesWithTitle.filter(emp => {
                                                                            const projects = getProjectsForWeek(emp, maxWeekDate);
                                                                            return projects.length === 0;
                                                                        }).length;
                                                                        
                                                                        showWarning = maxRequestCount > availableCount;
                                                                    }
                                                                    
                                                                    return (
                                                                        <div 
                                                                            key={dateIndex} 
                                                                            className={`labor-title-divider ${isCurrentMonth() ? 'current-week' : ''}`}
                                                                        >
                                                                            {maxRequestCount > 0 && (
                                                                                <div 
                                                                                    className={`labor-title-request-count ${showWarning ? 'warning' : ''}`}
                                                                                    onClick={() => maxWeekKey && handleRequestClick(title, maxWeekKey, projectNumber)}
                                                                                    title={showWarning ? `Warning: ${maxRequestCount} requested (week of ${maxWeekDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })})` : `${maxRequestCount} request${maxRequestCount !== 1 ? 's' : ''} (week of ${maxWeekDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })})`}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                >
                                                                                    {maxRequestCount}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                } else {
                                                                    // Week mode
                                                                    const weekEnd = new Date(periodStart);
                                                                    weekEnd.setDate(weekEnd.getDate() + 6);
                                                                    const isCurrentWeek = () => {
                                                                        const today = new Date();
                                                                        return today >= periodStart && today <= weekEnd;
                                                                    };
                                                                    
                                                                    const isMonthStart = dateIndex > 0 && 
                                                                        periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                                                    
                                                                    // Get request count from projectRequests - format date to match key format (M/D/YYYY)
                                                                    const dateKey = `${periodStart.getMonth() + 1}/${periodStart.getDate()}/${periodStart.getFullYear()}`;
                                                                    const requestCount = projectRequests?.[projectNumber]?.[dateKey]?.[title] || 0;
                                                                
                                                                    // Calculate available employees for this title in this week
                                                                    // Need to check ALL employees with this title (not just those in this project group)
                                                                    const allEmployeesWithTitle = [
                                                                        ...(procoreLaborList?.labor || []),
                                                                        ...(procoreLaborList?.subcontractor || []),
                                                                        ...(technicians || [])
                                                                    ].filter(emp => emp.title === title);
                                                                    
                                                                    // Available = employees with this title who have NO appointments at all this week
                                                                    const availableCount = allEmployeesWithTitle.filter(emp => {
                                                                        const projects = getProjectsForWeek(emp, periodStart);
                                                                        return projects.length === 0; // Employee has no appointments this week (completely available)
                                                                    }).length;
                                                                    
                                                                    const showWarning = requestCount > availableCount;
                                                                    
                                                                    return (
                                                                        <div 
                                                                            key={dateIndex} 
                                                                            className={`labor-title-divider ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                                        >
                                                                            {requestCount > 0 && (
                                                                                <div 
                                                                                    className={`labor-title-request-count ${showWarning ? 'warning' : ''}`}
                                                                                    onClick={() => handleRequestClick(title, dateKey, projectNumber)}
                                                                                    title={showWarning ? `Warning: ${requestCount} requested, only ${availableCount} available` : `${requestCount} request${requestCount !== 1 ? 's' : ''}`}
                                                                                >
                                                                                    {requestCount}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }
                                                            })}
                                                        </div>
                                                        
                                                        {/* Render employees for this title */}
                                                        {employees.map((employee, index) => (
                                                            <div key={employee.employeeId || `project-${projectNumber}-title-${title}-${index}`} className="labor-employee-row">
                                                                <div className="labor-employee-info">
                                                                    <div className="labor-employee-id">
                                                                        {employee.employeeId || 'N/A'}
                                                                    </div>
                                                                    <div className="labor-employee-name">
                                                                        {employee.name}
                                                                    </div>
                                                                    <div className="labor-employee-title">
                                                                        {employee.title}
                                                                    </div>
                                                                </div>
                                                                
                                                                {periodDates.map((periodStart, dateIndex) => {
                                                                    const projects = periodMode === 'month' ?
                                                                        getProjectsForMonth(employee, periodStart) :
                                                                        getProjectsForWeek(employee, periodStart);
                                                                    // Filter to only show appointments for this specific project
                                                                    const projectAppointments = projects.filter(p => p.projectNumber === projectNumber);
                                                                    
                                                                    if (periodMode === 'month') {
                                                                        const isCurrentMonth = () => {
                                                                            const today = new Date();
                                                                            return today.getFullYear() === periodStart.getFullYear() && 
                                                                                   today.getMonth() === periodStart.getMonth();
                                                                        };
                                                                        
                                                                        return (
                                                                            <div 
                                                                                key={dateIndex} 
                                                                                className={`labor-week-cell ${isCurrentMonth() ? 'current-week' : ''}`}
                                                                            >
                                                                                <div className="labor-week-content">
                                                                                    {projectAppointments.map((project, projectIndex) => {
                                                                                        // Get the title color from the titles array
                                                                                        const titleColor = titles?.find(t => t.name === employee.title)?.color || '#065943';
                                                                                        
                                                                                        return (
                                                                                            <div 
                                                                                                key={projectIndex} 
                                                                                                className="labor-project appointment-tile"
                                                                                                style={{ 
                                                                                                    backgroundColor: `${titleColor}66`, // Add 66 for 40% opacity (0.4 * 255 = 102 = 0x66)
                                                                                                    border: `2px solid ${titleColor}`,
                                                                                                    '--project-color': titleColor
                                                                                                }}
                                                                                                title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                                                            >
                                                                                                <div className="labor-project-number">
                                                                                                    {project.projectNumber}
                                                                                                </div>
                                                                                                <div className="labor-project-name">
                                                                                                    {project.projectName}
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    } else {
                                                                        const weekEnd = new Date(periodStart);
                                                                        weekEnd.setDate(weekEnd.getDate() + 6);
                                                                        const isCurrentWeek = () => {
                                                                            const today = new Date();
                                                                            return today >= periodStart && today <= weekEnd;
                                                                        };
                                                                        
                                                                        const isMonthStart = dateIndex > 0 && 
                                                                            periodStart.getMonth() !== periodDates[dateIndex - 1].getMonth();
                                                                    
                                                                        return (
                                                                            <div 
                                                                                key={dateIndex} 
                                                                                className={`labor-week-cell ${isCurrentWeek() ? 'current-week' : ''} ${isMonthStart ? 'month-start' : ''}`}
                                                                            >
                                                                                <div className="labor-week-content">
                                                                                    {projectAppointments.map((project, projectIndex) => {
                                                                                        // Get the title color from the titles array
                                                                                        const titleColor = titles?.find(t => t.name === employee.title)?.color || '#065943';
                                                                                        
                                                                                        return (
                                                                                            <div 
                                                                                                key={projectIndex} 
                                                                                                className="labor-project appointment-tile"
                                                                                                style={{ 
                                                                                                    backgroundColor: `${titleColor}66`, // Add 66 for 40% opacity (0.4 * 255 = 102 = 0x66)
                                                                                                    border: `2px solid ${titleColor}`,
                                                                                                    '--project-color': titleColor
                                                                                                }}
                                                                                                title={`${project.projectNumber} - ${project.projectName}\nTime: ${formatProjectTime(project.startTime, project.endTime)}\nWork Days: ${formatWorkDays(project.work_days || project.workDays)}\nWork Scope: ${project.workScopeText || 'N/A'}`}
                                                                                            >
                                                                                                <div className="labor-project-number">
                                                                                                    {project.projectNumber}
                                                                                                </div>
                                                                                                <div className="labor-project-name">
                                                                                                    {project.projectName}
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                })}
                                                            </div>
                                                        ))}
                                                    </>
                                                ));
                                        })()}
                                    </div>
                                                        ))}
                                                </React.Fragment>
                                            ))}
                                    </React.Fragment>
                                ))}
                        </>
                    )}
                    
                    {/* Show "No Data" message only if there are no titles at all or no matches after filtering */}
                    {viewMode === 'title' && (Object.keys(allTitleGroups).length === 0 || 
                      (Object.entries(allTitleGroups).every(([title, titleGroup]) => titleGroup.totalCount === 0) && 
                       titleFilter.length === 0 && nameSearch === '')) && (
                        <div className="labor-no-data">
                            <h3>No Labor Data Found</h3>
                            <p>
                                {titleFilter.length > 0 || nameSearch ? 
                                    'No employees match the current filter criteria.' : 
                                    'No employee, subcontractor, technician data or job titles are available.'
                                }
                            </p>
                        </div>
                    )}
                    
                    {/* Show "No Data" message for project view */}
                    {viewMode === 'project' && Object.keys(allProjectGroups).length === 0 && (
                        <div className="labor-no-data">
                            <h3>No Projects Found</h3>
                            <p>No active projects with labor assignments are available.</p>
                        </div>
                    )}
                </div>
            </div>
            
            {/* Request Details Modal */}
            {requestDetailsModal.isOpen && (
                <div className="labor-request-modal-overlay" onClick={() => setRequestDetailsModal({ ...requestDetailsModal, isOpen: false })}>
                    <div className="labor-request-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="labor-request-modal-header">
                            <h3>Labor Requests: {requestDetailsModal.title}</h3>
                            <p className="labor-request-modal-subtitle">
                                Week of {requestDetailsModal.weekKey} • {requestDetailsModal.requestCount} Total Request{requestDetailsModal.requestCount !== 1 ? 's' : ''}
                            </p>
                            <button 
                                className="labor-request-modal-close"
                                onClick={() => setRequestDetailsModal({ ...requestDetailsModal, isOpen: false })}
                            >
                                ×
                            </button>
                        </div>
                        <div className="labor-request-modal-content">
                            {requestDetailsModal.projects && requestDetailsModal.projects.length > 0 ? (
                                <div className="labor-request-projects-list">
                                    {requestDetailsModal.projects.map((project, index) => (
                                        <div key={index} className="labor-request-project-card">
                                            <div className="labor-request-project-header">
                                                <div 
                                                    className="labor-request-project-color"
                                                    style={{ backgroundColor: project.color || '#ccc' }}
                                                />
                                                <div className="labor-request-project-info">
                                                    <div className="labor-request-project-number">{project.number}</div>
                                                    <div className="labor-request-project-name">{project.name}</div>
                                                    <div className="labor-request-project-pm">{project.projectManager}</div>
                                                </div>
                                                <div className="labor-request-project-count">
                                                    {project.requestedCount} {project.requestedCount === 1 ? 'Request' : 'Requests'}
                                                </div>
                                            </div>
                                            <div className="labor-request-project-details">
                                                <div className="labor-request-project-detail">
                                                    <span className="label">Status:</span>
                                                    <span className={`value status-${project.status}`}>{project.status}</span>
                                                </div>
                                                {project.startDate && (
                                                    <div className="labor-request-project-detail">
                                                        <span className="label">Start Date:</span>
                                                        <span className="value">{new Date(project.startDate).toLocaleDateString()}</span>
                                                    </div>
                                                )}
                                                {project.endDate && (
                                                    <div className="labor-request-project-detail">
                                                        <span className="label">End Date:</span>
                                                        <span className="value">{new Date(project.endDate).toLocaleDateString()}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="labor-request-no-projects">
                                    <p>No project details available for these requests.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            
            {/* View Create/Edit Modal */}
            {viewModalOpen && (
                <div className="labor-view-modal-overlay" onClick={closeViewModal}>
                    <div className="labor-view-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="labor-view-modal-header">
                            <h3>{viewModalMode === 'create' ? 'Create New View' : 'Edit View'}</h3>
                            <button 
                                className="labor-view-modal-close"
                                onClick={closeViewModal}
                            >
                                ×
                            </button>
                        </div>
                        <div className="labor-view-modal-content">
                            <div className="labor-view-form-group">
                                <label>View Name</label>
                                <input
                                    type="text"
                                    className="labor-view-input"
                                    placeholder="Enter view name..."
                                    value={viewFormData.name}
                                    onChange={(e) => setViewFormData(prev => ({ ...prev, name: e.target.value }))}
                                />
                            </div>
                            
                            <div className="labor-view-form-group">
                                <label>Select Titles ({viewFormData.titles.length} selected)</label>
                                <div className="labor-view-titles-list">
                                    {availableTitles && availableTitles.length > 0 ? (
                                        availableTitles.map((title, index) => (
                                            <label key={`view-title-${index}`} className="labor-view-title-option">
                                                <input
                                                    type="checkbox"
                                                    checked={viewFormData.titles.includes(title)}
                                                    onChange={() => toggleViewTitleSelection(title)}
                                                />
                                                <span className="checkbox-custom"></span>
                                                <span className="option-text">{title}</span>
                                            </label>
                                        ))
                                    ) : (
                                        <div className="no-titles-message">No titles available</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="labor-view-modal-footer">
                            <button 
                                className="labor-view-modal-button cancel"
                                onClick={closeViewModal}
                            >
                                Cancel
                            </button>
                            <button 
                                className="labor-view-modal-button save"
                                onClick={saveView}
                            >
                                {viewModalMode === 'create' ? 'Create' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const IgnoredTitlesPopup = ({ isOpen, onClose, ignoredTitles, onSave, contextObject }) => {
    const [editingTitles, setEditingTitles] = useState([]);
    const [newTitle, setNewTitle] = useState('');
    const [activeTab, setActiveTab] = useState('edit'); // 'edit' or 'history'
    const [saving, setSaving] = useState(false);

    // Get the active record and initialize editing titles
    useEffect(() => {
        if (isOpen && Array.isArray(ignoredTitles) && ignoredTitles.length > 0) {
            const activeRecord = ignoredTitles.find(record => record.active);
            if (activeRecord && Array.isArray(activeRecord.titles)) {
                setEditingTitles([...activeRecord.titles]);
            } else {
                setEditingTitles([]);
            }
        } else {
            setEditingTitles([]);
        }
    }, [isOpen, ignoredTitles]);

    // Sort records with active record first, then by date in descending order
    const sortedHistory = Array.isArray(ignoredTitles) ? 
        [...ignoredTitles].sort((a, b) => {
            // Active record always comes first
            if (a.active && !b.active) return -1;
            if (!a.active && b.active) return 1;
            // If both are active or both are inactive, sort by date (newest first)
            return new Date(b.date) - new Date(a.date);
        }) : [];

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric'
        });
    };

    const handleAddTitle = () => {
        if (newTitle.trim() && !editingTitles.includes(newTitle.trim())) {
            setEditingTitles([...editingTitles, newTitle.trim()]);
            setNewTitle('');
        }
    };

    const handleRemoveTitle = (indexToRemove) => {
        setEditingTitles(editingTitles.filter((_, index) => index !== indexToRemove));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleAddTitle();
        }
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await onSave(editingTitles);
            onClose();
        } catch (error) {
            console.error('Error saving ignored titles:', error);
        } finally {
            setSaving(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className='ignored-titles-backdrop' onClick={onClose}>
            <div className='ignored-titles-popup' onClick={(e) => e.stopPropagation()}>
                <div className='ignored-titles-header'>
                    <h2>Manage Ignored Job Titles</h2>
                    <button 
                        className='ignored-titles-close-button' 
                        onClick={onClose}
                        aria-label="Close ignored titles manager"
                    >
                        <IoMdClose />
                    </button>
                </div>
                
                <div className='ignored-titles-tabs'>
                    <button 
                        className={`tab-button ${activeTab === 'edit' ? 'active' : ''}`}
                        onClick={() => setActiveTab('edit')}
                    >
                        Edit Current Titles
                    </button>
                    <button 
                        className={`tab-button ${activeTab === 'history' ? 'active' : ''}`}
                        onClick={() => setActiveTab('history')}
                    >
                        Change History
                    </button>
                </div>

                <div className='ignored-titles-content'>
                    {activeTab === 'edit' && (
                        <div className='edit-titles-section'>
                            <div className='add-title-section'>
                                <h3>Add New Title to Ignore</h3>
                                <div className='add-title-input-group'>
                                    <input
                                        type="text"
                                        className='add-title-input'
                                        placeholder="Enter job title to ignore..."
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                    <button 
                                        className='add-title-button'
                                        onClick={handleAddTitle}
                                        disabled={!newTitle.trim() || editingTitles.includes(newTitle.trim())}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className='current-titles-section'>
                                <h3>Currently Ignored Titles ({editingTitles.length})</h3>
                                <div className='titles-list'>
                                    {editingTitles.length === 0 ? (
                                        <p className='no-titles-message'>No titles are currently being ignored.</p>
                                    ) : (
                                        editingTitles.map((title, index) => (
                                            <div key={index} className='title-item'>
                                                <span className='title-name'>{title}</span>
                                                <button 
                                                    className='remove-title-button'
                                                    onClick={() => handleRemoveTitle(index)}
                                                    title="Remove this title"
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            <div className='popup-actions'>
                                <button 
                                    className='cancel-button'
                                    onClick={onClose}
                                    disabled={saving}
                                >
                                    Cancel
                                </button>
                                <button 
                                    className='save-button'
                                    onClick={handleSave}
                                    disabled={saving}
                                >
                                    {saving ? 'Saving...' : 'Save Changes'}
                                </button>
                            </div>
                        </div>
                    )}

                    {activeTab === 'history' && (
                        <div className='history-section'>
                            <h3>Change History</h3>
                            <div className='history-list'>
                                {sortedHistory.length === 0 ? (
                                    <p className='no-history-message'>No change history available.</p>
                                ) : (
                                    sortedHistory.map((record, index) => (
                                        <div 
                                            key={record.id || index} 
                                            className={`history-item ${record.active ? 'active-record' : ''}`}
                                        >
                                            <div className='history-header'>
                                                <div className='history-meta'>
                                                    <span className='history-date'>{formatDate(record.date)}</span>
                                                    <span className='history-modifier'>
                                                        Modified by: {record.modifier || 'Unknown'}
                                                    </span>
                                                    {record.active && (
                                                        <span className='active-badge'>Current</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='history-titles'>
                                                <strong>Ignored Titles ({record.titles?.length || 0}):</strong>
                                                {record.titles && record.titles.length > 0 ? (
                                                    <div className='titles-grid'>
                                                        {record.titles.map((title, titleIndex) => (
                                                            <span key={titleIndex} className='history-title-tag'>
                                                                {title}
                                                            </span>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <span className='no-titles-text'>No titles were ignored</span>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const Dashboard = () => {
    const contextObject = useContext(Context);
    const moduleOptions = ['P&L Dashboard', 'Projects Dashboard', 'Labor & Equipment Dashboard'];
    const [ completeResults, setCompleteResults ] = useState();
    const [ currentVersion, setCurrentVersion ] = useState();
    const [ errors, setErrors ] = useState();
    const [ moduleSelection, setModuleSelection ] = useState('P&L Dashboard');
    const [ refreshingStats, setRefreshingStats ] = useState(false);
    const [ creatingOverUnderAdjustments, setCreatingOverUnderAdjustments ] = useState(false);
    const [ overUnderDocument, setOverUnderDocument ] = useState('');

    const [ selectedStat, setSelectedStat ] = useState({});
    const [ selectedTitle, setSelectedTitle ] = useState('Company - EBITA');
    const [ branchSelected, setBranchSelected ] = useState('Company');
    const [ branchList, setBranchList ] = useState();
    const [ sectionSelected, setSectionSelected ] = useState('ebita');
    const [ sectionList, setSectionList ] = useState();

    const [ projectsList, setProjectsList ] = useState({});

    // LABOR & EQUIPMENT
    const [ laborTimeStamp, setLaborTimeStamp ] = useState(null);
    const [ refreshingLaborData, setRefreshingLaborData ] = useState(false);
    const [ procoreLaborList, setProcoreLaborList ] = useState(null);
    const [ procoreErrors, setProcoreErrors ] = useState(null);
    const [ projectRequests, setProjectRequests ] = useState(null);
    const [ projectRequestsErrors, setProjectRequestsErrors ] = useState(null);
    const [ weeklyRequests, setWeeklyRequests ] = useState(null);
    const [ weeklyRequestsErrors, setWeeklyRequestsErrors ] = useState(null);
    const [ titles, setTitles ] = useState(null);
    const [ titlesErrors, setTitlesErrors ] = useState(null);
    const [ projects, setProjects ] = useState(null);
    const [ projectsErrors, setProjectsErrors ] = useState(null);

    const [ completeTechList, setCompleteTechList ] = useState(null);
    const [ completeTechErrors, setCompleteTechErrors ] = useState(null);
    const [ fieldServiceLaborList, setFieldServiceLaborList ] = useState(null);
    const [ fieldServiceErrors, setFieldServiceErrors ] = useState(null);

    const [ laborReport, setLaborReport ] = useState(null);
    const [ laborReportErrors, setLaborReportErrors ] = useState(null);

    const [ editingIgnoredTitles, setEditingIgnoredTitles ] = useState(false);
    const [ ignoredTitles, setIgnoredTitles ] = useState([]);
    const [ ignoredTitlesErrors, setIgnoredTitlesErrors ] = useState(null);

    const [ leViews, setLeViews ] = useState(null);
    const [ leViewsErrors, setLeViewsErrors ] = useState(null);

    const setProjectsDashboardList = (filterBy=null,filterValue=null,groupBy='Branch') => {
        let projects = {};
        if(!completeResults || !completeResults.branchStats) return;
        
        if(groupBy === 'Branch'){
            if(!filterBy){
                // Sort branch IDs numerically by converting to numbers
                const sortedBranchIds = Object.keys(completeResults.branchStats).sort((a, b) => Number(a) - Number(b));
                
                sortedBranchIds.forEach(branchId => {
                    if(completeResults.branchStats[branchId].totalProjects > 0){
                        // Initialize branch structure
                        const branch = completeResults.branchStats[branchId];
                        projects[branchId] = {
                            name: branch.branchName,
                            id: branchId,
                            openProjects: 0,
                            closedProjects: 0,
                            totalProjects: 0,
                            overdueAR: branch.overdueAR,
                            overBilled: branch.overBilled,
                            underBilled: branch.underBilled,
                            overUnder: branch.overUnder,
                            requiredProjectAdjustment: branch.requiredProjectAdjustment,
                            projectManagers: {}, // Changed from projects to projectManagers
                        };
                        
                        // Group projects by project manager
                        Object.keys(branch.projects).forEach(projectId => {
                            const project = branch.projects[projectId];

                            if(project.projectType === 'Project' || project.projectType === 'Maintenance' || project.projectType === 'Intercompany') {
                                const pmName = project.projectManagerName || 'Unassigned';
                                
                                // Initialize project manager if not exists
                                if(!projects[branchId].projectManagers[pmName]) {
                                    projects[branchId].projectManagers[pmName] = {
                                        name: pmName,
                                        id: project.projectManager || 'UNASSIGNED',
                                        email: project.projectManagerEmail || '',
                                        openProjects: 0,
                                        closedProjects: 0,
                                        totalProjects: 0,
                                        overdueAR: 0,
                                        overUnder: 0,
                                        projects: {}
                                    };
                                }
                                
                                // Add project to project manager
                                projects[branchId].projectManagers[pmName].projects[projectId] = project;
                                projects[branchId].projectManagers[pmName].totalProjects += 1;
                                projects[branchId].projectManagers[pmName].overdueAR += project.overdueAR || 0;
                                projects[branchId].projectManagers[pmName].overUnder += project.overUnder || 0;
                                
                                if(project.status === 'Active') {
                                    projects[branchId].projectManagers[pmName].openProjects += 1;
                                }
                                if(project.status === 'Closed') {
                                    projects[branchId].projectManagers[pmName].closedProjects += 1;
                                }
                                
                                // Update branch totals
                                projects[branchId].totalProjects += 1;
                                if(project.status === 'Active') projects[branchId].openProjects += 1;
                                if(project.status === 'Closed') projects[branchId].closedProjects += 1;
                            }
                        });

                        // Remove branch if no projects
                        if(projects[branchId].totalProjects === 0) {
                            delete projects[branchId];
                        }
                    }
                });

                setProjectsList(projects);
            }
        }

        if(groupBy === 'None'){
        }
    };

    useEffect(() => {
        if (sectionList && sectionSelected) {
            setSelectedStat(sectionList[sectionSelected].stats);
            setSelectedTitle(sectionList[sectionSelected].name);
        };
    }, [branchSelected, sectionSelected, completeResults, sectionList]);

    const createSectionList = () => {
        const sections = {};
        Object.keys(branchList[branchSelected].stats.budgetedVsActual).forEach(category => {
            let temporarySection = {};
            if(branchList[branchSelected].name === 'Company'){
                temporarySection = {
                    name: `${branchSelected} - ${branchList[branchSelected].stats.budgetedVsActual[category].name}`,
                    id: category,
                    stats: branchList[branchSelected].stats.budgetedVsActual[category],
                };
            }
            else{
                temporarySection = {
                    name: `${branchSelected} ${branchList[branchSelected].name} - ${branchList[branchSelected].stats.budgetedVsActual[category].name}`,
                    id: category,
                    stats: branchList[branchSelected].stats.budgetedVsActual[category],
                };
            }
            sections[temporarySection.id] = temporarySection;
        });
        setSectionList(sections);
    };
    useEffect(() => {
        if(branchList && branchSelected)  createSectionList();
        setSectionSelected('ebita');
    }, [branchSelected,branchList]);

    const initializeBranches = () => {
        let branches = {
            'Company': {
                name: 'Company',
                id: 'Company',
                stats: completeResults.companyStats,
            },
        };
        Object.keys(completeResults.branchStats).forEach(branchId => {
            const branchStats = completeResults.branchStats[branchId];
            if(branchId !== '00' && branchId !== '05' && branchId !== '92' ) {
                branches[branchId] = {
                    name: branchStats.branchName,
                    id: branchStats.branchId,
                    stats: branchStats,
                };
            }
        });
        setBranchList(branches);
        setBranchSelected('Company');
    };
    useEffect(() => {
        if(completeResults){
            initializeBranches();
            setProjectsDashboardList();
            setCurrentVersion(`${completeResults.monthName} ${completeResults.day} ${completeResults.year} - ${completeResults.time}`);
        };
    }, [completeResults]);

    const refreshLaborStats = () => {
        setRefreshingLaborData(true);
        setLaborTimeStamp(null);
        setProcoreLaborList(null);
        setWeeklyRequests(null);
        setProjectRequests(null);
        setTitles(null);
        setProjects(null);
        setFieldServiceLaborList(null);
        setCompleteTechList(null);
        refreshLaborData(contextObject.apiToken,setProcoreLaborList,setProcoreErrors,setProjectRequests,setProjectRequestsErrors,setWeeklyRequests,setWeeklyRequestsErrors,setTitles,setTitlesErrors,setProjects,setProjectsErrors,setLaborTimeStamp,setRefreshingLaborData);
        getFieldServiceLaborData(contextObject.apiToken,setFieldServiceLaborList,setFieldServiceErrors);
        getCompleteTechData(contextObject.apiToken,setCompleteTechList,setCompleteTechErrors);
    };

    useEffect(() => {
        if(!completeResults) getCompleteCompanyStats(contextObject.apiToken,setCompleteResults,setErrors);
        if(!procoreLaborList) getProcoreLaborData(contextObject.apiToken,setProcoreLaborList,setProcoreErrors,setProjectRequests,setProjectRequestsErrors,setWeeklyRequests,setWeeklyRequestsErrors,setTitles,setTitlesErrors,setProjects,setProjectsErrors,setLaborTimeStamp);
        if(!fieldServiceLaborList) getFieldServiceLaborData(contextObject.apiToken,setFieldServiceLaborList,setFieldServiceErrors);
        if(!completeTechList) getCompleteTechData(contextObject.apiToken,setCompleteTechList,setCompleteTechErrors);
        if(!ignoredTitles || ignoredTitles.length === 0) getIgnoredTitles(contextObject.apiToken,setIgnoredTitles,setIgnoredTitlesErrors);
        if(!leViews) getLEViews(contextObject.apiToken,setLeViews,setLeViewsErrors);
    },[]);

    const LoadingWindow = ({}) => {
        return (
            <div className='Dashboard-Loading-Window'>
                <div className='Dashboard-Loading-Container'>
                    <div className='Dashboard-Loading-Content'>
                        <div className='Dashboard-Loading-Icon'>
                            <Loader />
                        </div>
                        <div className='Dashboard-Loading-Text-Container'>
                            <h2 className='Dashboard-Loading-Title'>Loading Dashboard</h2>
                            <p className='Dashboard-Loading-Subtitle'>Fetching the latest Acumatica data...</p>
                        </div>
                    </div>
                    <div className='Dashboard-Loading-Background-Pattern'></div>
                </div>
            </div>
        )
    };

    const ErrorWindow = ({}) => {
        return (
            <div className='Dashboard-Error-Pane'>

            </div>
        )
    };

    const generateLaborReport = () => {
        generateLaborEquipmentReport(contextObject.apiToken, setLaborReport, setLaborReportErrors);
    };

    const generateOverUnderAdjustment = () => {
        createOverUnderDocument(contextObject.apiToken, setOverUnderDocument, setErrors, setCreatingOverUnderAdjustments);
    };

    const createNewStats = () => {
        setRefreshingStats(true);
        setOverUnderDocument(null);
        setCreatingOverUnderAdjustments(false);
        createNewCompanyStats(contextObject.apiToken,setCompleteResults,setErrors,setRefreshingStats);
    };

    const editIgnoredTitles = () => {
        setEditingIgnoredTitles(true);
    };

    const modifyIgnoredTitles = async (newTitles) => {
        return new Promise((resolve, reject) => {
            updateIgnoredTitles(
                contextObject.apiToken, 
                {titles: newTitles, modifier: contextObject.activeUser.email}, 
                (updatedTitles) => {
                    getIgnoredTitles(contextObject.apiToken,setIgnoredTitles,setIgnoredTitlesErrors);
                    getProcoreLaborData(contextObject.apiToken,setProcoreLaborList,setProcoreErrors,setProjectRequests,setProjectRequestsErrors,setWeeklyRequests,setWeeklyRequestsErrors,setTitles,setTitlesErrors,setProjects,setProjectsErrors,setLaborTimeStamp);
                    setEditingIgnoredTitles(false);
                    resolve(updatedTitles);
                }, 
                (error) => {
                    setIgnoredTitlesErrors(error);
                    reject(error);
                }
            );
        });
    };

    const navigationBarProps = {
        accessToken: contextObject.apiToken,
        currentVersion:currentVersion,
        createNewStats:createNewStats,
        moduleSelection: moduleSelection,
        setModuleSelection: setModuleSelection,
        moduleOptions:moduleOptions,
        refreshingStats:refreshingStats,
        generateOverUnderAdjustment:generateOverUnderAdjustment,
        overUnderDocument:overUnderDocument,
        generateLaborReport:generateLaborReport,
        laborReport:laborReport,
        laborTimeStamp:laborTimeStamp,
        refreshLaborStats:refreshLaborStats,
        editIgnoredTitles:editIgnoredTitles,
        refreshingLaborData:refreshingLaborData,
    };

    const LaborEquipmentDashboardProps = {
        procoreLaborList:procoreLaborList,
        fieldServiceLaborList:fieldServiceLaborList,
        completeTechList:completeTechList,
        weeklyRequests:weeklyRequests,
        projectRequests:projectRequests,
        titles:titles,
        projects:projects,
        accessToken:contextObject.apiToken,
    };


    return (
        <div className='Dashboard-Window'>
            {editingIgnoredTitles && (
                <IgnoredTitlesPopup 
                    isOpen={editingIgnoredTitles}
                    onClose={() => setEditingIgnoredTitles(false)}
                    ignoredTitles={ignoredTitles}
                    onSave={modifyIgnoredTitles}
                    contextObject={contextObject}
                />
            )}
            {completeResults &&
                <>
                    <NavigationBar {...navigationBarProps} />
                    {   moduleSelection === 'P&L Dashboard' &&
                        <div className='Dashboard-Primary-Display'>
                            <div className='Dashboard-Summary-Branch-Display'>
                                {branchList &&
                                    <>
                                        {/* Show 'Company' first, then other branches sorted by id */}
                                        <div
                                            key="Company"
                                            className={`Dashboard-Branch-Summary ${branchSelected === 'Company' ? 'selected' : ''}`}
                                            onClick={() => setBranchSelected('Company')}
                                        >
                                            <BranchTile title={'Company'} stats={branchList['Company'].stats} />
                                        </div>
                                        {Object.values(branchList)
                                            .filter(branch => branch.id !== 'Company')
                                            .sort((a, b) => {
                                                // Sort by id (as string, but you can cast to number if needed)
                                                if (a.id < b.id) return -1;
                                                if (a.id > b.id) return 1;
                                                return 0;
                                            })
                                            .map(branch => (
                                                <div
                                                    key={branch.id}
                                                    className={`Dashboard-Branch-Summary ${branch.id === branchSelected ? 'selected' : ''}`}
                                                    onClick={() => setBranchSelected(branch.id)}
                                                >
                                                    <BranchTile title={branch.name} stats={branch.stats} />
                                                </div>
                                            ))}
                                    </>
                                }
                            </div>
                            <div className='Dashboard-Summary-Main-Display'>
                                {   selectedStat && selectedTitle &&
                                    <div className='Dashboard-Stats-Group-Content'>
                                        <BudgetLineChart
                                            data={selectedStat}
                                            width={1000}
                                            height={500}
                                            title={selectedTitle}
                                        />
                                    </div>
                                }

                            </div>
                            <div className='Dashboard-Summary-Section-Display'>
                                {sectionList &&
                                    Object.values(sectionList)
                                        .filter(section => {
                                            // Only include sections where at least one actual value is non-zero
                                            const actualArray = section.stats.actual || [];
                                            return actualArray.some(entry => entry.value !== 0);
                                        })
                                        .map(section => (
                                            <div
                                                key={section.id}
                                                className={`Dashboard-Section-Summary ${section.id === sectionSelected ? 'selected' : ''}`}
                                            >
                                                <SectionTile 
                                                    title={section.stats.name} 
                                                    id={section.id}
                                                    stats={section.stats} 
                                                    sectionSelected={sectionSelected} 
                                                    setSectionSelected={setSectionSelected} 
                                                />
                                            </div>
                                        ))
                                }
                            </div>
                        </div>
                    }
                    {   moduleSelection === 'Projects Dashboard' &&
                        <div className='Dashboard-Primary-Display'>
                            <ProjectsDashboard projectsList={projectsList}/>
                        </div>
                    }
                    {   moduleSelection === 'Labor & Equipment Dashboard' &&
                        <div className='Dashboard-Primary-Display'>
                            <LaborEquipmentDashboard {...LaborEquipmentDashboardProps} />
                        </div>
                    }

                </>
            }
            {
                !completeResults && !errors &&
                <LoadingWindow />
            }
            {errors &&
                <ErrorWindow />
            }
        </div>
    )
};

export default Dashboard;